// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../images/white-round.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.cus-err {
    color: #D8000C;
    position: absolute;
    left: 5px;
    bottom: 0px;
    font-size: 13px;
}

/*  */
.iti,
.iti--allow-dropdown {
    width: 100%;
    margin-bottom: 20px;
}

.reg-g-captcha-main {
    position: relative;
    padding: 10px 0 20px;
}

.iti__tel-input {
    width: 100%;
    padding: 10px 15px;
    border-radius: 12px;
    outline: none !important;
    box-shadow: none !important;
    border: 2px solid #E6E8EC;
    /* margin-bottom: 15px; */
    margin-bottom: 20px;
}

/* Loader */
.preloader {
    position: fixed;
    right: 0;
    left: 0;
    top: 0;
    bottom: 0;
    opacity: 0.5;
    background-color: white;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    z-index: 2000 !important;
}

.preloader span {
    text-transform: uppercase;
    font-size: 12px;
    letter-spacing: 2px;
    margin-top: 15px;
}

.preloader .preloader-icon,
.inside-loader .preloader-icon {
    border: 2px solid #eeeeee;
    border-radius: 50%;
    border-top: 2px solid #E3BD3E;
    width: 70px;
    height: 70px;
    animation: spin 0.5s linear infinite !important;
}

@keyframes spin {
    0% {
        transform: rotate(0deg);
    }

    100% {
        transform: rotate(360deg);
    }
}

/* .no-scroll {
    overflow: hidden;
} */

/* Loader Ends */
.commonInput.greenSpan {
    border: 2px solid #2ABC30 !important;
}



.adultDropBox {
    /* max-height: 0; */
    /* overflow: hidden; */
    transition: max-height 0.2s ease-in-out;
}


/* .adultDropBox {
    display: block;
} */
.bookRightBox .selectDate .multyDrop .adultDropBox ul {
    background-color: white;
}

@keyframes slideDown {
    from {
        max-height: 0;
        opacity: 0;
        transform: translateY(-20px);
    }

    to {
        max-height: 150px;
        opacity: 1;
        transform: translateY(0);
    }
}

@keyframes slideUp {
    from {
        max-height: 150px;
        opacity: 1;
        transform: translateY(0);
    }

    to {
        max-height: 0;
        opacity: 0;
        transform: translateY(-20px);
    }
}

.adultDropBox.open,
.dateDropBox.open,
.timeDropBox.open {
    display: block;
    animation: slideDown 0.2s ease-out forwards;
}

.adultDropBox.close,
.dateDropBox.close,
.timeDropBox.close {
    animation: slideUp 0.2s ease-out forwards;
}

.flatpickr-input {
    padding: 20px 20px;
    border-radius: 15px;
    background: white;
}

.ourClickBox.accordion-body .flatpickr-input {
    /* box-shadow: 0px 0px 10px var(--border-color) !important; */
    box-shadow: none !important;
}

body.dark .flatpickr-input {
    background-color: #1f1f1f;
}

.detailsSlider .sliderImg {
    height: 475px;
}

.detailsSlider .sliderImg img {
    object-fit: cover;
    width: 100%;
    height: 100%;
}

.owl-next:hover,
.owl-prev:hover {
    background: transparent !important;
    opacity: 0.5 !important;
}


.pageSection2 .Section2Box .travelBox {
    box-shadow: none !important;
    transition: 0.3s;
}

.pageSection2 .Section2Box .travelBox:hover {
    box-shadow: 0px 0px 30px #dbdbdb !important;
}

/* HTML: <div class="loader"></div> */
/* .listloader {
    width: 60px;
    aspect-ratio: 2;
    --_g: no-repeat radial-gradient(circle closest-side,#000 90%,#0000);
    background: 
      var(--_g) 0%   50%,
      var(--_g) 50%  50%,
      var(--_g) 100% 50%;
    background-size: calc(100%/3) 50%;
    animation: l3 1s infinite linear;
  }
  @keyframes l3 {
      20%{background-position:0%   0%, 50%  50%,100%  50%}
      40%{background-position:0% 100%, 50%   0%,100%  50%}
      60%{background-position:0%  50%, 50% 100%,100%   0%}
      80%{background-position:0%  50%, 50%  50%,100% 100%}
  } */

/* HTML: <div class="loader"></div> */
.listloader {
    width: 50px;
    aspect-ratio: 1;
    border-radius: 50%;
    background:
        radial-gradient(farthest-side, #E3BD3E 94%, #0000) top/8px 8px no-repeat,
        conic-gradient(#0000 30%, #E3BD3E);
    -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 8px), #000 0);
    animation: l13 1s infinite linear;
}

@keyframes l13 {
    100% {
        transform: rotate(1turn)
    }
}

/* .paginationBox .pagination .page-item .page-link {
    border: unset !important;
} */

.exploreTour .pagenext {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 10px;
}

.exploreTour .ourTourBox .leftImg img {
    height: 250px;
}

/*  */
.iti,
.ourdetailProfile.profileImport .iti {
    display: flex !important;
    gap: 10px !important;
}

.iti__country-container,
.ourdetailProfile.profileImport .iti__country-container {
    position: unset !important;
    border-radius: 12px;
    border: 2px solid #E6E8EC;
    width: 170px;
}

.iti__tel-input,
.ourdetailProfile.profileImport .iti__tel-input {
    padding-left: 10px !important;
}

.iti__selected-country,
.ourdetailProfile.profileImport .iti__selected-country {
    width: 100%;
}

.iti__arrow,
.ourdetailProfile.profileImport .iti__arrow {
    border-left: 0 !important;
    border-right: 0 !important;
    margin-left: 0 !important;
}

.iti__arrow::after {
    content: '\\f078';
    font-family: 'fontawesome';
    position: absolute;
    right: 4px;
    font-size: 11px;
    margin-left: 10px;
    height: 25px;
    width: 25px;
    border: 2px solid #E6E8EC;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    top: 50%;
    transform: translateY(-50%);
}

.iti .iti__selected-dial-code {
    margin-left: 3px !important;
}

.iti__selected-country-primary {
    padding-right: 0 !important;
}

.iti__selected-country-primary:hover {
    background-color: transparent !important;
}

.iti__search-input {
    outline: none !important;
    border: 2px solid #E6E8EC;
    padding: 10px 15px;
    border-radius: 12px;
}

/* .req-sym {
    color: #fa5c7c;
    margin-left: 0.3rem;
} */
/* .companyProfilePage .boxCard{
    position: relative ;

}
.companyProfilePage .cus-err{
    bottom: -20px !important;
} */
body.dark .activityhead .backBox a,
body.dark .activityhead .backBox a i {
    color: #B1B5C3 !important;
}

body.dark .rightTabcontent .pagenext .pageList p {
    color: #B1B5C3 !important;

}

body.dark .filtersearchbtn {
    color: #B1B5C3 !important;
}

.mainDetailsBox .ourTourBox {
    box-shadow: none !important;
    transition: 0.3s;
}

.mainDetailsBox .ourTourBox:hover {
    box-shadow: 0px 0px 30px #dbdbdb !important;
}

.filterpage .flatpickr-day.selected {
    background-color: #E3BD3E !important;
    color: #23262F !important;
}

.prevMonthDay {
    visibility: hidden !important;
}

.nextMonthDay {
    visibility: hidden !important;

}

.innerFormBox .box-box,
.boxFull,
.fillDetails .nameBox .box-box {
    position: relative;
}

.commonLabel {
    width: 100%;
    padding-bottom: 5px;
    color: #292929;
    font-family: 'Manrope-Regular';
}

.full_description_text {
    font-family: 'Manrope-Regular';
}

/* .full_description_text  {
    font-family: sans-serif, Arial, Verdana, "Trebuchet MS";
} */

/* 
.full_description_text p {
    font-size: unset;
    color: unset;
}

.full_description_text ul {
    list-style: unset !important;
    margin: unset !important;
    padding: unset !important;
    padding-left: 2rem !important;
    margin-top: 0 !important;
    margin-bottom: 1rem !important;
} */
.full_description_text p {
    margin-top: 0;
    margin-bottom: 1rem;
    font-size: 1rem;
    line-height: 1.5;
    color: #212529;
}

.full_description_text ul {
    padding-left: 2rem;
    margin-top: 0;
    margin-bottom: 1rem;
    list-style-type: disc;
}

.full_description_text ol {
    padding-left: 2rem;
    margin-top: 0;
    margin-bottom: 1rem;
    list-style-type: decimal;
}

.full_description_text li {
    margin-bottom: 0.5rem;
}

.full_description_text h1 {
    margin-top: 0;
    margin-bottom: 0.5rem;
    font-size: 2.5rem;
    font-weight: 500;
    line-height: 1.2;
}

.full_description_text h2 {
    margin-top: 0;
    margin-bottom: 0.5rem;
    font-size: 2rem;
    font-weight: 500;
    line-height: 1.2;
}

.full_description_text h3 {
    margin-top: 0;
    margin-bottom: 0.5rem;
    font-size: 1.75rem;
    font-weight: 500;
    line-height: 1.2;
}

.full_description_text h4 {
    margin-top: 0;
    margin-bottom: 0.5rem;
    font-size: 1.5rem;
    font-weight: 500;
    line-height: 1.2;
}

.full_description_text h5 {
    margin-top: 0;
    margin-bottom: 0.5rem;
    font-size: 1.25rem;
    font-weight: 500;
    line-height: 1.2;
}

.full_description_text h6 {
    margin-top: 0;
    margin-bottom: 0.5rem;
    font-size: 1rem;
    font-weight: 500;
    line-height: 1.2;
}

.full_description_text div {
    font-size: 1rem;
    line-height: 1.5;
    color: #212529;
}

.typeBox .sendBtn .crossBtn {
    background-color: #E2E8F0;
}

.typeBox .search-key,
header .header-box .search-key {
    min-height: 100px;
}

.detasilBox.typeBox {
    background: none;
    padding: 0;
}

.typeBox .search-key ul h6 i {
    color: var(--gold-color) !important;
    position: unset !important;
    transform: none !important;
}

.dropDownLoc {
    z-index: 999;
}

.updateImg {
    position: relative;
    /* display: inline-block; */
}

/* Hide the file input */
#avatarInput {
    display: none;
}

/* Style the label as a button or link */
.custom-file-upload {
    cursor: pointer;
    color: var(--gold-color);
    text-decoration: none;
    /* font-size: 14px; */
    display: inline-flex;
    align-items: center;
}

.custom-file-upload i {
    margin-right: 5px;
}


.rightProfile .rightProfileMain .userImgBox .updateImg label {
    color: var(--gold-color);
    font-family: 'Manrope-SemiBold';
    margin-top: 10px;
}

.commonGoldBtn {
    background-color: #E3BD3E !important;
}

.flatpickr-day.selected {
    background-color: #E3BD3E !important;
    color: #23262F !important;
    background: #E3BD3E !important;
    border: unset !important;
}

.flatpickr-day {
    font-family: 'Gilory-SemiBold' !important;
    font-size: 15px;
    border: none !important;
}

.commonInputSecond.flatpickr-input {
    box-shadow: unset !important;
    z-index: 55;
    position: relative;
    background: transparent;
    padding-left: 40px;
}

.rightProfileMain .cus-err {
    bottom: -20px !important;
}

.phoneBox .cus-err {
    bottom: 0px !important;
}

.formHeaderTitle {
    display: flex;
    align-items: center;
}

.header-part .searchBox {
    display: none !important;
}

.header-part .searchBox.visible {
    display: block !important;
}

.bokunDropBox.custom-cal .iconDown {
    height: 35px;
    width: 35px;
    border: 2px solid #E6E8EC;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 10px;
}

.bokunDropBox.custom-cal .bi-calendar-week-fill {
    color: #64748b;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    left: 10px;
}

.profileImport .userPersonaldet .toptitle h5 {
    color: rgba(35, 38, 47, 1) !important;
}

.iti__country {
    display: flex !important;
    align-items: center !important;
    padding: 8px var(--iti-spacer-horizontal) !important;
    outline: none !important;
}

.iti__dial-code {
    color: var(--iti-dialcode-color) !important;
}

.iti__country-list .iti__flag,
.iti__country-name {
    margin-right: var(--iti-spacer-horizontal) !important;
}

.iti__country-name,
.iti__dial-code {
    font-size: 13px !important;
}

.rightProfileMain .iti--inline-dropdown .iti__dropdown-content {
    z-index: 999 !important;
    width: 240px !important;
}

.userAc {
    display: block !important;
    z-index: 99;
}

.rightProfile .rightProfileMain .userPersonaldet {
    margin-bottom: 100px;
}

.ti-widget-header {
    padding: 0 !important;
}

/* .ti-load-more-reviews-container .ti-load-more-reviews-button {
    color: var(--text-black) !important;
    border: 2px solid #E6E8EC !important;
    font-size: 16px !important;
    padding: 8px 15px !important;
    box-shadow: none !important;
    border-radius: 30px !important;
    font-family: 'Gilroy-Bold' !important;
    width: 100% !important;
    border-top-width: 2px !important;
    border-bottom-width: 2px !important;
    border-left-width: 2px !important;
    border-right-width: 2px !important;
} */

.pageSection2 .Section2Box .priceBox {
    align-items: center;
}

.pageSection2 .Section2Box .priceBox .priceListTag h5 {
    font-size: 16px;
}

.pageSection2 .Section2Box .priceBox .priceListTag,
.pageSection2 .Section2Box .priceBox .listRating {
    width: calc(50% - 5px);
}

.pageSection2 .Section2Box .priceBox .listRating .ti-header {
    padding: 0 !important;
}

.filterpagereview .ti-header.source-Tripadvisor,
.filterpagereview .ti-header.ti-header-grid.source-all,
.filterpagereview .ti-header.ti-header-grid.source-Google {
    padding: 10px !important;
}

/* .full_description_text_activity a {
    all: revert !important;
} */

/* .full_description_text_activity {
    overflow: hidden;
    display: -webkit-box;
    -webkit-line-clamp: 3; 
    -webkit-box-orient: vertical;
}

.full_description_text_activity.expanded {
    -webkit-line-clamp: unset; 
} */

/* .full_description_text_activity {
    max-height: 70px;
    overflow: hidden;
    transition: max-height 0.3s ease-in-out;
}

.full_description_text_activity.expanded {
    max-height: 100%;
} */

.dropDownLoc {
    background-color: rgba(253, 253, 253, 1) !important;
    top: 40px !important;
}

.dropDownLoc li.newdropOpen ul.innerNewDrop {
    background-color: rgba(253, 253, 253, 1) !important;
    max-height: 340px !important;
    overflow-y: auto;
}

.dropDownLoc li.newdropOpen ul.innerNewDrop::-webkit-scrollbar-track {
    border-radius: 8px;
    background-color: #f5f5f0;
}

.dropDownLoc li.newdropOpen ul.innerNewDrop::-webkit-scrollbar {
    width: 4px;
    background-color: #f5f5f0;
}

.dropDownLoc li.newdropOpen ul.innerNewDrop::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: var(--gold-color);
}


header .header-box .logoBox .locationBox {
    padding: 12px 0;
}

.dropDownLoc li a:hover {
    background-color: rgba(253, 247, 232, 1);
}

header .header-box .logoBox .locationBox a.active {
    color: var(--gold-color);
}

header .header-box .logoBox .locationBox a.active i {
    transition: 0.2s all linear;
}

header .header-box .logoBox .locationBox a.active i {
    transform: rotate(180deg);
}


.mainBanner .bannerBox .bannerText.homepagebanner {
    max-width: 600px;
    margin: 0 auto;
}

.mainBanner .bannerBox .bannerText.homepagebanner .sliderText p {
    margin-bottom: 0 !important;
}

.mainBanner .bannerBox .bannerText.homepagebanner .sliderText h2 {
    font-size: 50px;
}

.suggetionRecord {
    border-bottom: 1px solid #F1F5F9;
    margin-bottom: 0px !important;
}

.mainBanner {
    min-height: 490px;
}

.pageSection2 .Section2Box .priceBox {
    min-height: 57px;
}

.typeBox .search-key,
header .header-box .menuBox .search-key {
    box-shadow: 0px 10px 20px #00000026 !important;
}

.listingld-label {
    font-size: 16px;
    font-weight: bold;
    color: #e3bd3e;
}

.mainBanner::after {
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.35) 0%, rgba(0, 0, 0, 0) 100%) !important;
}

.gallery .galleryPart .galleryBox .imgGridBox::after {
    /* background: linear-gradient(0deg, rgb(0 0 0 / 35%) 0%, rgb(253 253 253 / 0%) 55%); */
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.35) 0%, rgb(253 253 253 / 0%) 55%);

}

.tourStyle .tourStylepart .tourBox .tourGallery .imgBox::after {
    /* background: linear-gradient(0deg, rgb(0 0 0 / 35%) 0%, rgb(253 253 253 / 0%) 55%); */
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.35) 0%, rgb(253 253 253 / 0%) 55%);

}

#full_description_text_activity {
    display: -webkit-box;
    -webkit-box-orient: vertical;
    overflow: hidden;
    transition: all 0.3s ease-in-out;
}

#full_description_text_activity.collapsed {
    -webkit-line-clamp: 6;
}

#full_description_text_activity.expanded {
    -webkit-line-clamp: unset;
    overflow: visible;
}

.exploreTour .ourTourBox.skeleton::after {
    z-index: 9 !important;
}


.selectDetails .accordion-item .accordion-button {
    border: 2px solid #E6E8EC !important;
    padding: 10px 20px !important;
    border-radius: 15px !important;
    background: var(--white-color) !important;
    color: #777777;
    font-family: 'Poppins-Medium';
    font-size: 18px;
    box-shadow: none !important;
}

.selectDetails .accordion-flush .accordion-item {
    border: none !important;
    box-shadow: none !important;
    margin-bottom: 15px;
    background-color: transparent;
}

.selectDetails .accordion-flush .accordion-body {
    padding: 0 !important;
}

.selectDetails .accordion-item .accordion-button i {
    color: #292D32;
    margin-right: 10px;
}

.selectDetails .accordion-item .accordion-button::after {
    content: '\\f078';
    font-family: 'fontawesome';
    background-image: none;
    border: 2px solid #E6E8EC;
    border-radius: 50%;
    height: 35px;
    width: 35px;
    display: flex;
    align-items: center;
    justify-content: center;
}

.selectDetails .accordion-flush .accordion-item:hover {
    background-color: transparent !important;
}

.adultDropBox,
.timeDropBox,
.dateDropBox {
    display: block;
    position: unset;
}

.bookRightBox .adultDropBox ul {
    padding: 20px 20px;
    /* box-shadow: 0px 0px 10px var(--border-color); */
    border-radius: 15px;
}

.bookRightBox .adultDropBox ul li:not(:last-child) {
    padding-bottom: 10px;
    margin-bottom: 15px;
    border-bottom: 1px solid var(--border-color);
}

.bookRightBox .adultDropBox ul li {
    display: flex;
    align-items: center;
    justify-content: space-between;
}

.bookRightBox .adultDropBox ul li .adultage h6 {
    font-size: 18px;
    font-family: 'Gilory-SemiBold';
}

.bookRightBox .adultDropBox ul li .adultage span {
    font-size: 14px;
    color: var(--input-color);
    font-family: 'Gilroy-Regular';
}

.bookRightBox .adultDropBox ul li .countBtn i {
    color: #83889B;
    font-size: 25px;
    vertical-align: middle;
    cursor: pointer;
}

.bookRightBox .adultDropBox ul li .countBtn span {
    font-size: 18px;
    padding: 0 20px;
    color: #83889B;
}

.bookRightBox .timeDropBox ul {
    background: #FCFCFD;
    padding: 20px 20px;
    /* box-shadow: 0px 0px 10px var(--border-color); */
    border-radius: 12px;
    display: grid;
    grid-template-columns: 1fr 1fr;
    text-align: center;
    gap: 10px;
}

.bookRightBox .timeDropBox ul li a {
    width: 100%;
    background-color: #E3BD3E1A;
    border: 1px solid var(--gold-color);
    color: #2C2F3A;
    border-radius: 5px;
    padding: 10px 0px;
    font-family: 'Gilory-SemiBold';
    transition: 0.3s;
}

.bookRightBox .timeDropBox ul li a:hover {
    background-color: var(--gold-color);
}

.selectDetails .accordion-flush .accordion-button:not(.collapsed) {
    border-color: var(--gold-color) !important;
}

.selectDetails .ourClickBox .dayContainer {
    min-width: 100% !important;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    justify-content: center !important;
    text-align: center !important;
    margin: 0 auto;
}

.selectDetails .ourClickBox .flatpickr-day.today:hover {
    color: #393939 !important;
}

.flatpickr-day.today:hover {
    color: #393939 !important;
}

.flatpickr-months .flatpickr-prev-month:hover svg,
.flatpickr-months .flatpickr-next-month:hover svg {
    fill: #FFD166 !important;
}

.selectDetails .ourClickBox .flatpickr-day {
    max-width: 38px !important;
    height: 38px !important;
    width: 38px;
    margin: 0 auto 8px;
}

@media (max-width:575px) {
    .selectDetails .accordion-item .accordion-button::after {
        height: 30px;
        width: 30px;
        font-size: 16px;
    }

    .selectDetails .accordion-item .accordion-button {
        font-size: 16px;
    }

    .selectDetails .ourClickBox .flatpickr-monthDropdown-months,
    .selectDetails .ourClickBox .numInput.cur-year {
        width: 100px !important;
        font-size: 16px !important;
    }
}


@media (max-width:350px) {
    .selectDetails .ourClickBox .flatpickr-input {
        padding: 20px 0px !important;
    }
}

.bookable-date::after {
    content: "";
    display: block;
    width: 5px;
    height: 5px;
    background-color: #ECBB33 !important;
    border-radius: 50%;
    position: absolute;
    bottom: 5px;
    left: 50%;
    transform: translateX(-50%);
}

.available-date {
    background-color: #FDF7E8 !important;
    color: #334155 !important;
    /* border-radius: 50% !important;  */
}

.flatpickr-day.selected.bookable-date::after {
    background-color: #44444F !important;

}

/* .ourClickBox .flatpickr-day.today {
    border: 1px solid  !important;
    border-color: #959ea9 !important;
    background-color: unset !important;
} */

.selectDetails .ourClickBox .flatpickr-day:hover {
    background-color: #e6e6e6 !important;
}

.selectDetails .ourClickBox .flatpickr-day.available-date:hover {
    background-color: #e3bc3e29 !important;
}

.selectDetails .ourClickBox .flatpickr-day.selected:hover {
    background: #E3BD3E !important;
}

/* .selectDetails .ourClickBox .flatpickr-day.bookable-date:hover {
    background-color: #FDF7E8 !important;
} */
.selectDetails .ourClickBox .numInputWrapper .arrowDown,
.selectDetails .ourClickBox .numInputWrapper .arrowUp {
    display: none;

}

.selectDetails .ourClickBox .numInputWrapper .cur-year {
    pointer-events: none !important;

}

.full_description_text img {
    max-width: 100% !important;
    height: auto !important;
}

.mainBanner {
    margin: unset;
    border-radius: unset;
}

.mainBanner::after {
    border-radius: unset;
}

.selectDetails .ourClickBox .flatpickr-day.today {
    background-color: unset
}

/* Rates  */
.rate-card {
    cursor: pointer;
    border: 2px solid transparent;
    border-radius: 16px;
    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);
    transition: all 0.3s ease-in-out;
    background: #fff;
    padding: 20px;
    position: relative;
    overflow: hidden;
    text-align: left;
}

.rate-card:hover {
    transform: translateY(-5px);
    box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.15);
}

.rate-card.selected {
    border: 2px solid #e3bd3e;
    background: #fff9e6;
    box-shadow: 0px 10px 25px rgba(227, 189, 62, 0.4);
    /* transform: scale(1.03); */
}

.badge-selected {
    font-size: 14px;
    background: #e3bd3e;
    color: #fff;
    padding: 6px 12px;
    border-radius: 20px;
    display: none;
    font-weight: 600;
    align-items: center;
    gap: 2px;
}

.rate-card.selected .badge-selected {
    display: inline-flex;
}

.rate-header {
    font-size: 18px;
    font-weight: 600;
    color: #333;
    margin-bottom: 10px;
    width: 100%;
    max-width: 80%;
}

.divider {
    height: 1px;
    background: #ddd;
    margin: 12px 0;
}

.policy {
    display: flex;
    align-items: baseline;
    font-size: 14px;
    color: #555;
    margin-bottom: 8px;
}

.policy i {
    color: #e3bd3e;
    margin-right: 8px;
}

.price {
    font-size: 24px;
    font-weight: bold;
    color: #e3bd3e !important;
    position: absolute;
    bottom: 15px;
    right: 15px;
    transition: color 0.3s ease-in-out;
}

.rate-card.selected .price {
    color: #b29730 !important;
}

/* Ticket */
.ticket {
    /* width: 450px; */
    background: white;
    border-radius: 16px;
    position: relative;
    /* overflow: hidden; */
    border: 2px solid #f5f5f5;

}

/* Ticket Header with Gradient Overlay */
.ticket-header {
    height: 75px;
    position: relative;
    color: white;
    text-align: center;
    padding: 20px;
    font-size: 22px;
    font-weight: bold;
    background: url('https://tourexplorer.s3.ap-south-1.amazonaws.com/images/product/f6b9a69b-4a79-497a-bff5-1588625418e6.jpeg') center/cover;
    border-top-left-radius: 14px;
    border-top-right-radius: 14px;
}

.ticket-header::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    /* background: linear-gradient(to bottom, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0)); */
    border-top-left-radius: 14px;
    border-top-right-radius: 14px;
}

.ticket-header span {
    position: relative;
    z-index: 1;
}

/* Ticket Cutout Effect */
.ticket:before,
.ticket:after {
    content: "";
    position: absolute;
    width: 20px;
    height: 40px;
    background: #fff;
    border: 2px solid #f5f5f5;
    /* border-radius: 50%;s */
}

.ticket:before {
    top: 50%;
    left: -2px;
    transform: translateY(-50%);
    z-index: 9999;
    border-left: 0;
    border-top-right-radius: 30px;
    border-bottom-right-radius: 30px;
}

.ticket:after {
    top: 50%;
    right: -2px;
    transform: translateY(-50%);
    border-right: 0;
    border-top-left-radius: 30px;
    border-bottom-left-radius: 30px;
}

/* Ticket Body */
.ticket-body {
    padding: 10px 20px;
    text-align: center;
}

.ticket-time {
    font-size: 26px;
    font-weight: bold;
    color: #333;
}

.ticket-date {
    font-size: 18px;
    color: #777;
    margin-bottom: 10px;
}

.ticket-divider {
    border-top: 2px dashed #bbb;
    margin: 12px 0;
}

/* Pricing Details */
.ticket-info {
    display: flex;
    justify-content: space-between;
    font-size: 16px;
    margin-bottom: 8px;
    color: #555;
}

.ticket-info i {
    color: #e3bd3e;
    margin-right: 6px;
}

/* Total Amount */
.total-amount {
    font-size: 18px;
    font-weight: bold;
    text-align: right;
    color: #e3bd3e;
}

.personDrop select {
    width: 100%;
    border: 2px solid #E6E8EC !important;
    border-radius: 10px;
    padding: 5px 5px;
    margin-top: 10px;
    outline: none;
}

.selectDetails .ourClickBox .nextMonthDay {
    display: none !important;
}

.gallery .galleryPart .imgGridBox .textBox {
    padding-right: 10px;
}

.atag_btn {
    /* display: block; */
    /* width: 115px; */
    /* height: 25px; */
    background: transparent;
    border: 1px solid #E3BD3E;
    padding: 10px;
    text-align: center;
    border-radius: 5px;
    color: white;
    font-weight: bold;
    line-height: 25px;
    color: #E3BD3E;
}

.atag_btn:hover {
    /* background: #E3BD3E; */
    color: #E3BD3E;
}

.dropDownLoc li.newdropOpen ul.innerNewDrop {
    width: 100%;
    min-width: 460px !important;
}

.dropDownLoc li.newdropOpen ul.innerNewDrop li {
    width: 33%;
}

.dropDownLoc li.newdropOpen ul.innerNewDrop li a {
    word-break: break-word;
}

.dropDownLoc li.newdropOpen:hover ul.innerNewDrop {
    display: inline-flex;
}

.personDrop .bokunDropBox ul.DropBox {
    padding: 10px !important;
}

.personDrop .bokunDropBox ul.DropBox li {
    margin-bottom: 0 !important;
}

.personDrop .bokunDropBox ul.DropBox li a {
    padding: 0 15px !important;
}

.personDrop .discriplangDown a.main {
    padding: 5px 12px;
}

.personDrop .discriplangDown a.main .iconDown {
    height: 25px;
    width: 25px;
}

.personDrop .discriplangDown a.main .iconDown i {
    font-size: 13px;
}

.personDrop .boxCard .commonLabelSecond {
    margin-top: 5px !important;
}

.mainListProducts .tabBtnbox ul li .custombtn .fa-chevron-right {
    float: unset;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    right: 0;
}

.header-fav-icon a {
    color: var(--text-black);
    padding: 5px 10px;
    border-radius: 30px;
    font-family: 'Manrope-Bold';
    transition: 0.3s;
}

.header-fav-icon a.active {
    background-color: var(--white-color);
}

.header-fav-icon a i {
    margin-right: 5px;
    vertical-align: middle;
}

.full_description_text_activity img {
    max-width: 100% !important;
    height: auto !important;
}

.admin-visible-detail p {
    line-height: 1;
}

.innerNewDrop {
    display: flex;
    flex-wrap: wrap;
    max-width: 460px;
}

.innerNewDrop li {
    width: calc(33.33% - 10px);
    list-style: none;
    text-align: left;
}

.location_mobile .dropDownLocMobile li .innerNewDrop li {
    width: calc(100%) !important;
}

.time-selected {
    background-color: #e3bd3e !important;
}

ul.innerNewDrop a {
    font-size: 12px !important;
}

.soldout-time {
    border: unset !important;
    color: #2c2f3a29 !important;
    cursor: not-allowed !important;
    /* opacity: 0.5 !important; */
}

.soldout-time:hover {
    background-color: #E3BD3E1A !important;
}

.req-sym {
    color: #fa5c7c;
    margin-left: 0.3rem;
}

.checkout-form .cus-err {
    position: relative !important;
}

.checkout-form .iti,
.iti--allow-dropdown {
    margin-bottom: 0 !important;

}

.cat-blog-short-desc {
    display: -webkit-box;
    -webkit-line-clamp: 4;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100%;
}

.innerFormBox .box-box {
    width: calc(50%);
}

.innerFormBox {
    display: flex;
    /* grid-template-columns: 1fr 1fr; */
    gap: 30px;
    margin-bottom: 25px;
}

.select2.select2-container {
    width: 100% !important;
}

span.selection {
    width: 100%;
}

.select2.select2-container .selection .select2-selection {
    border: 2px solid #E6E8EC;
    display: flex;
    align-items: center;
    /* padding: 20px 0px; */
    height: 48px;
    border-radius: 10px;
}

.select2-container--default .select2-selection--single .select2-selection__arrow {
    top: 50% !important;
    transform: translateY(-50%);
    height: 35px !important;
    width: 35px !important;
    border: 2px solid #E6E8EC;
    border-radius: 50%;
    right: 15px !important;
}

.select2-container--default .select2-selection--single .select2-selection__arrow::after {
    content: '\\f078';
    position: absolute;
    font-family: 'fontawesome';
    font-size: 16px;
    padding: 3px 8px;
}

.confirm_left .select2-container--default .select2-selection--single .select2-selection__arrow b {
    display: none;
}

.discriplangDown a.main {
    padding: 6px 15px;
}

.react-date-picker {
    width: 100%;
}

.react-date-picker__wrapper {
    border: none !important;
    padding: 8px 15px !important;
    border-radius: 12px !important;
    border: 2px solid var(--border-color) !important;
}

.react-date-picker__inputGroup {
    color: #7A7C86 !important;
    font-size: 14px !important;
    font-family: 'Manrope-Medium' !important;
}

.react-date-picker__button svg {
    stroke: #7A7C86 !important;
}

.react-date-picker__button svg:hover {
    stroke: #E3BD3E !important;
}

.react-calendar {
    border: none !important;
    border-radius: 30px;
    background-color: #FCFCFD !important;
    /* box-shadow: 0 40px 32px -24px #0F0F0F1F !important; */
    box-shadow: 0 0px 5px 0px #0F0F0F1F !important;
    padding: 15px 10px;
}

.react-calendar__month-view .react-calendar__tile {
    font-size: 14px !important;
    width: 50px !important;
    max-width: 45px !important;
    height: 45px;
    font-family: 'Poppins-Medium' !important;
}

.react-calendar__month-view .react-calendar__tile--active {
    color: var(--dark-box) !important;
    border-radius: 50% !important;
    background: #ECBB33 !important;
    padding: 0 !important;
}

/* .react-calendar__month-view__days__day--neighboringMonth {
    color: var(--dark-box) !important;
} */

.react-calendar__month-view__days {
    display: grid !important;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
}

.react-calendar__month-view .react-calendar__month-view__weekdays {
    color: #83889B !important;
    font-family: 'Gilory-SemiBold' !important;
    text-transform: capitalize !important;
    text-decoration: none !important;
    font-size: 14px !important;
}

.react-calendar__month-view .react-calendar__month-view__weekdays abbr[title] {
    text-decoration: unset !important;
    font-family: 'Gilory-SemiBold' !important;
}

.react-calendar__month-view .react-calendar__month-view__days__day--weekend {
    color: var(--dark-box);
}

.react-calendar__navigation .react-calendar__navigation__label__labelText {
    font-size: 18px;
    color: var(--dark-box);
    font-family: 'Manrope-Bold' !important;
}

.react-calendar__month-view__days__day--neighboringMonth {
    color: #757575 !important;
}

.react-calendar__tile--now {
    background: transparent !important;
}

.react-calendar__month-view .react-calendar__tile:enabled:hover,
.react-calendar__month-view .react-calendar__tile:enabled:focus {
    /* background-color: #ECBB33 !important; */
    border-radius: 50% !important;
}

.react-calendar__year-view .react-calendar__tile--hasActive,
.react-calendar__decade-view__years .react-calendar__tile--hasActive,
.react-calendar__century-view__decades .react-calendar__tile--hasActive {
    background: #ECBB33 !important;
}

.react-calendar__year-view .react-calendar__tile,
.react-calendar__decade-view__years .react-calendar__tile,
.react-calendar__century-view__decades .react-calendar__tile {
    padding: 12px 20px !important;
    border-radius: 30px;
    color: var(--dark-box);
    font-size: 14px;
    font-family: 'Gilory-SemiBold' !important;
    /* font-family: 'Gilroy-Bold'!important; */
    margin-bottom: 10px;
}

.react-calendar__century-view__decades .react-calendar__tile {
    padding: 12px 5px !important;
}

.confirm_and_pay .confirm_left .select2-container--default .select2-selection--single .select2-selection__placeholder {
    font-family: 'Poppins-Medium';
    color: #23262F;
}

.verification-modal .modal-dialog {
    max-width: 480px;
}

.verification-modal .modal-content {
    border-radius: 16px;
}

.verification-modal .modal-body {
    text-align: center;
    padding: 30px 30px;
    border-radius: 16px;
}

.verification-modal .modal-body a>img {
    width: 100%;
    max-width: 190px;
}

.verification-modal .modal-body h4 {
    color: #0F172A;
    font-size: 30px;
    margin: 15px 0;
    font-family: 'Gilroy-Bold';
}

.verification-modal .modal-body h6 {
    font-size: 14px;
    color: #94A0AD;
    margin-bottom: 25px;
    font-family: 'Gilroy-Bold';
}

.verification-modal .modal-body .register p {
    color: #475569;
    font-size: 16px;
    font-family: 'Manrope-SemiBold';
    margin-top: 20px;
}

.verification-modal .modal-body .register p a {
    font-family: 'Manrope-SemiBold';
}

.blogContainer .commonInput {
    margin-bottom: 0;
    background-color: #f5f5f0;
    padding-right: 25px;
}

.blogContainer .commonInput::placeholder {
    font-family: 'Poppins-Regular';
    color: var(--gray-color);
}

.blogSearch {
    position: relative;
}

.blogSearch i {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--gray-color);
}

.pageSection2.blogPage .Section2Box .placeSec {
    margin-top: 0;
}

.customTitle {
    color: #334155;
    font-family: 'Manrope-Bold';
}

.confirm_left .paymentTab {
    margin-bottom: 0;
}

.confirm_left .paymentTab .continueBox {
    margin-top: 30px;
}

/* .StripeElement {
    padding: 12px 15px;
    border-radius: 12px;
    border: 2px solid var(--border-color);
} */
.stripe-custom-form .commonInputSecond {
    padding: 13px !important;

}

.stripe-custom-form .card-branding {
    border: unset !important;
}

.checkoutsublabels {
    color: #334155 !important;
    margin-bottom: 5px;
}

.location-page-exp {
    padding: 10px 0 !important;
}

.blogPage .pagenext {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 25px;
}

.profilePhoneInput .cus-err {
    bottom: -20px !important;
}

.detailsMore span.greenstatuspaid {
    background: #17C964;
    padding: 0px 10px;
    border-radius: 5px;
    font-size: 12px;
    color: black;
    padding: 4px 4px;
}

.detailsMore span.comtagSpan {
    padding: 0px 10px;
    border-radius: 5px;
    font-size: 14px;
    font-family: 'Manrope-SemiBold' !important;
}

.detailsMore span.comtagSpan.green {
    background-color: #17C96433;
    color: #09A54D;
}

.detailsMore span.comtagSpan.blue {
    background-color: #006FEE33;
    color: #006FEE;
}

.booking-pagination-par .pagenext {
    display: flex;
    justify-content: space-between;
    align-items: center;
}

.booking-product-list-select .select2-selection__rendered {
    width: 100% !important;
}

.detailsMore .accordion-body .ourbtnsec .btn.resendbtn {
    color: #292D32;
    background-color: #E3BD3E;
    border: unset;
}

.detailsMore .accordion-body .ourbtnsec .btn.cancelbtn {
    background-color: #DC2626;
    border: unset;
    color: white;

}

.activityhead .breadcrumb {
    margin: 0;
}

/*  */

.payment-container {
    /* background: rgba(255, 255, 255, 0.95); */
    padding: 0px 40px;
    width: 420px;
    text-align: center;
    border-radius: 16px;
    /* box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.12); */
    position: relative;
    backdrop-filter: blur(10px);
}

.payment-icon {
    width: 80px;
    height: 80px;
    background: #e3bd3e;
    color: white;
    font-size: 36px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 50%;
    margin: 0 auto 20px;
    box-shadow: 0px 5px 15px rgba(227, 189, 62, 0.3);
}

.processing-title {
    font-size: 30px;
    font-weight: 600;
    margin-bottom: 10px;
    color: #23262F;
    font-family: 'Manrope-SemiBold';
}

.processing-loading-text {
    font-size: 16px;
    font-weight: 700;
    color: #94A3B8;
    font-family: 'Manrope-Regular';
}

.processing-expire-note {
    font-size: 16px;
    font-weight: 600;
    color: #475569;
    font-family: 'Manrope-Regular';
}

/*  */

.registerBox .form-group .btnShow {
    position: absolute;
    top: 50%;
    right: 0;
    color: #83889B;
    box-shadow: none !important;
    transform: translateY(-50%);
}

.registerBox .form-group {
    position: relative;
}

.registerBox .form-group .lineSpan {
    padding: 15px 0;
}

.registerBox .form-group label {
    color: #292929;
    font-size: 14px;
    font-family: 'Manrope-Medium';
    padding-bottom: 10px;
}

.custom-ui {
    text-align: center;
    width: 500px;
    padding: 40px;
    /* background: #28bae6; */
    background-color: var(--gold-color);
    color: var(--text-black) !important;
    box-shadow: 0 20px 75px rgba(0, 0, 0, 0.23);
    /* color: #fff !important; */
    border-radius: 10px !important;
}

.custom-ui>button {
    width: 160px !important;
    padding: 10px !important;
    border: 1px solid #fff;
    margin: 10px !important;
    cursor: pointer;
    background: none;
    color: #fff;
    font-size: 14px;
}

.custom-ui>h1 {
    font-family: 'Manrope-SemiBold' !important;
    margin-top: 0;
    color: #fff;
    font-size: 2.5rem !important;

}

.custom-ui>p {
    margin-top: 0;
    color: #fff;

}

.imgText {
    cursor: pointer !important;
}

.custom-ui button:hover {
    background: white !important;
    color: var(--gold-color) !important;
}

.verification-modal.confirmation-modal .modal-dialog {
    max-width: 567px;
}

.verification-modal.confirmation-modal .modal-body h4 {
    color: #23262F;
    font-family: 'Manrope-Bold' !important;
}

.verification-modal.confirmation-modal .modal-body h6 {
    color: #94A3B8;
    font-family: 'Manrope-Regular' !important;
}

.verification-modal.confirmation-modal .continueBox {
    display: flex;
    gap: 10px;
}

.verification-modal.confirmation-modal .continueBox .continueBtn {
    width: calc(50%);
    background: #fff;
    border: 1px solid var(--gold-color);
    font-family: 'Manrope-SemiBold' !important;
}

.verification-modal.confirmation-modal .continueBox .continueBtn:hover {
    background: var(--gold-color);
}

.modal-backdrop.show {
    opacity: .9;
    background-color: var(--dark-box)d9;
}

.detailsMore .accordion-body .ourbtnsec {
    margin-top: 20px;
    display: flex;
    justify-content: center;
    gap: 10px;
}

.detailsMore .accordion-body .ourbtnsec .btn.two {
    width: calc(50% - 10px);
}

.detailsMore .accordion-body .ourbtnsec .btn.single {
    width: calc(100%);
}

.customBtnGold {
    background: var(--gold-color);
    width: 100px;
    font-family: 'Manrope-Bold';
    border-radius: 30px;
    min-height: 45px;
    color: #23252E;
    outline: unset;
    border: unset;
}

.profileBackbtnContainer {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
}

span.red {
    color: #F31260;
    background-color: #F3126033;
}

.redColorText {
    color: #950606 !important;
}

.topstatus {
    font-size: 12px !important;
    padding: 4px 10px !important;
}

.search-title {
    margin-bottom: 10px !important;
}

.typeBox .search-key ul li:not(:last-child),
header .header-box .menuBox .search-key ul li:not(:last-child) {
    margin-bottom: 0px !important;
}

.typeBox .search-key ul li a,
header .header-box .menuBox .search-key ul li a {
    padding: 5px 5px !important;

}

.cancelRedBtn {
    background-color: #e53935;
    /* Bright red */
    color: #fff;
    /* White text */
    border: none;
    padding: 10px 20px;
    font-size: 16px;
    font-weight: 500;
    border-radius: 6px;
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.cancelRedBtn:hover {
    background-color: #c62828;
    /* Darker red on hover */
}

.whatsappbtn {
    background-color: #25D366 !important;
    color: white !important;
}

.detailsMore .accordion-body .ourbtnsec .btn i {
    vertical-align: initial !important;
}

.mainListProducts .tabBtnbox ul li .custombtn svg {
    vertical-align: bottom;
    margin-right: 10px;
}

.dropDownLoc.iocnDropdwon {
    width: auto !important;
}

.dropDownLoc.iocnDropdwon li a {
    justify-content: start !important;
    gap: 10px !important;
}

.dropdownBox span.dropdown-icon {
    margin-right: 5px;
    vertical-align: text-bottom;
}

/*  */
/* Hide all language sections by default */
.English-section,
.French-section,
.German-section,
.Italian-section,
.Portuguese-section,
.Other-section,
.Spanish-section {
    display: none;
}

.goog-te-banner-frame {
    display: none !important;
}

/* Show the matching section based on body class */
body.English .English-section {
    display: block;
}

body.French .French-section {
    display: block;
}

body.German .German-section {
    display: block;
}

body.Italian .Italian-section {
    display: block;
}

body.Portuguese .Portuguese-section {
    display: block;
}

body.Spanish .Spanish-section {
    display: block;
}

body.Other .Other-section {
    display: block;
}

body.Other .goog-te-banner-frame {
    display: block !important;
}

.tandcLink {
    color: #ECBB33 !important;
    text-decoration: underline;
    font-size: 16px;
    font-family: 'Manrope-Medium';
}

.tandcMainDiv {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
}

.skiptranslate {
    opacity: 0;
    visibility: hidden;
}

body.Other .skiptranslate {
    opacity: 1;
    visibility: visible;
}

/* .skiptranslate {
    display: none !important;
}

body.Other .skiptranslate {
   display: block ;
} */

body {
    top: 0px !important;
}

iframe .VIpgJd-ZVi9od-TvD9Pc-hSRGPd {
    display: none !important;
}

.VIpgJd-ZVi9od-aZ2wEe-wOHMyf.VIpgJd-ZVi9od-aZ2wEe-wOHMyf-ti6hGc {
    display: none !important;
}

.footerPart .footerBox .innerBox .footermenu.fiveBox ul li span img {
    width: 100% !important;
    max-width: 30px !important;
}

.blog-cat-opt {
    width: 30%;
}

.currencyDrop {
    opacity: 0.5;
}

.currencyDrop a {
    cursor: not-allowed;
}

.goog-te-banner-close {
    display: none !important;
}

#full_description_text_cms table {
    width: 100%;
    border-collapse: collapse;
    table-layout: auto;
    /* or fixed if you want consistent column widths */
}

#full_description_text_cms td,
#full_description_text_cms th {
    word-wrap: break-word;
    /* padding: 8px; */
    /* border: 1px solid #ddd;s */
}

#full_description_text_cms td img {
    width: 100% !important;
    height: 100% !important;
    object-fit: contain;
}

#full_description_text_cms table {
    width: 100% !important;
}

#full_description_text_cms table td h4,
#full_description_text_cms table td h1 {
    font-family: 'Manrope-Bold';
}

#full_description_text_cms table td p {
    font-family: 'Manrope-Regular';
}

.custom-red-label {
    color: red;
    font-family: 'Manrope-Bold';
    font-size: 22px;
    margin-bottom: 20px;
    /* padding-left: 15px; */
}

.comon-tags-class h1 {
    font-family: 'Manrope-Bold';
    font-size: 48px;
    /* color: #0F172A !important; */
    color: #f39c12 !important;

}

.comon-tags-class h2 {
    font-family: 'Manrope-Bold';
    font-size: 40px;
    color: #BBBE11 !important;
}

.comon-tags-class h3 {
    font-family: 'Manrope-Bold';
    font-size: 32px;
    color: #ECBB33 !important;
}

.comon-tags-class h4 {
    font-family: 'Manrope-Bold';
    font-size: 24px;
    color: #EEC144 !important;
}

.comon-tags-class h5 {
    font-family: 'Manrope-Bold';
    font-size: 20px;
    color: #334155 !important;
}

.comon-tags-class h6 {
    font-family: 'Manrope-Bold';
    font-size: 18px;
    color: #FCD34D !important;
}

#goog-gt-tt {
    display: none !important;
    visibility: hidden !important;
    opacity: 0 !important;
    z-index: -9999 !important;
}

#goog-gt-tt {
    position: absolute !important;
    top: 20px !important;
    /* move to top */
    left: 20px !important;
    z-index: 9999 !important;
}

.faqs_section .question_box {
    padding-left: 15px !important;
}

.contact-us-content .about_banner {
    padding-bottom: 0px;
}

body.dark .comon-tags-class h5,
body.dark .comon-tags-class h2,
body.dark .faqs_section .accordion-button,
body.dark .faqs_section .accordion-body {
    color: #fff !important;
}

body.dark .send_email span {
    color: #B1B5C3 !important;
}

body.dark .faqs_section .accordion-item {
    background-color: var(--dark-box) !important;
}

.content_box_dyn {
    padding: 0 15px;
}

body.dark .menuBread .breadcrumb-item+.breadcrumb-item::before {
    filter: invert(0.6);
}

.full_description_text iframe {
    width: 100%;
}


.full_description_text blockquote {
    font-style: italic;
    padding: 2px 0;
    border-style: solid !important;
    border-color: #ccc !important;
    border-width: 0;
    padding-left: 20px;
    padding-right: 8px;
    border-left-width: 5px;
}

blockquote {
    display: block;
    margin-block-start: 1em;
    margin-block-end: 1em;
    margin-inline-start: 40px;
    margin-inline-end: 40px;
    unicode-bidi: isolate;
}

blockquote {
    border-left: 4px solid #ccc;
    padding-left: 1em;
    margin: 1em 0;
    color: #444;
    background-color: #f9f9f9;
    font-style: italic;
}

.notranslate {
    translate: no !important;
}

.timeBox_second {
    margin-top: 16px;
}

.bookRightBox .adultDropBox ul li .adultage {
    width: 100%;
    max-width: 75%;
}

.bookRightBox .adultDropBox ul li .personDrop {
    width: 100%;
    max-width: 25%;
}

.menuBread .breadcrumb .breadcrumb-item span {
    word-break: break-word;
    display: flex;
}

.bookRightBox .adultDropBox ul li .personDrop .countBtn {
    display: flex;
}



.ourClickBox span.flatpickr-weekday {
    translate: unset !important
}

/*  */
.full_description_text_activity table {
    width: 100%;
    border-collapse: collapse;
    margin-top: 1em;
    border: 1px solid #ccc;
}

.full_description_text_activity th,
.full_description_text_activity td {
    border: 1px solid #ccc;
    padding: 0.6em 0.8em;
    vertical-align: top;
}

.full_description_text_activity th {
    text-align: left;
    font-size: 1.2em;
    color: #f0b429;
    background-color: #f9f9f9;
}

.full_description_text_activity tr td:first-child {
    font-weight: bold;
    white-space: nowrap;
    width: 140px;
}

.full_description_text_activity strong {
    font-weight: bold;
    /* color: #000; */
}

.full_description_text_activity {
    font-size: 1em;
    line-height: 1.5;
    color: #333;
    background-color: #fefefe;
}

.meetingPoint .clickMap .realExpMapBox {
    margin-top: 20px;
}

.meetingPoint .clickMap .realExpMapBox iframe {
    width: 100%;
    min-height: 300px;
    border-radius: 24px;
}

.meetingPoint .clickMap .routeMapBox {
    margin-top: 20px;
}

.meetingPoint .clickMap .routeMapBox iframe {
    width: 100%;
    min-height: 300px;
    border-radius: 24px;
}

.filterSidebarList {
    max-height: 250px;
    overflow: auto;
}

/*  */


.ourClickBox .comSeacrh_input .titleCat {
    display: flex;
    align-items: center;
    gap: 5px;
    width: 100%;
}

.ourClickBox .comSeacrh_input .titleCat p {
    margin-bottom: 0 !important;
}

.ourClickBox .comSeacrh_input .searchBox {
    position: relative;
    margin: 10px 0;
    min-height: 45px;
    width: 100%;
}

.ourClickBox .comSeacrh_input .searchBox a.iconS,
.ourClickBox .comSeacrh_input .searchBox a.iconX {
    background: var(--white-color);
    height: 33px;
    width: 33px;
    border-radius: 5px;
    display: flex;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    transition: 0.6s;
    right: 5px;
    float: right;
    border: 1px solid #ccc;
}

.ourClickBox .comSeacrh_input .searchBox a.iconS {
    z-index: 2;
}

.ourClickBox .comSeacrh_input .searchBox.active a.iconS {
    background: var(--white-color);
    transition: 0.5s;
}

.ourClickBox .comSeacrh_input .searchBox a.iconX {
    opacity: 0;
}

.ourClickBox .comSeacrh_input .searchBox.active a.iconX {
    right: 5px;
    border: 1px solid var(--border-color);
    opacity: 1;
    z-index: 55;
}

.ourClickBox .comSeacrh_input .searchBox a i {
    color: var(--text-black);
    font-size: 18px;
}

.ourClickBox .comSeacrh_input .searchBox input {
    background: var(--white-color);
    border: none;
    box-shadow: none;
    height: 40px;
    width: 0px;
    border-radius: 50%;
    transition: 0.5s;
    opacity: 0;
    outline: none;
    float: right;
}

.ourClickBox .comSeacrh_input .searchBox.active input {
    max-width: 270px;
    border-radius: 7px;
    height: 45px;
    padding: 0 42px 0px 10px;
    width: 100%;
    border: 1px solid var(--border-color);
    opacity: 1;
}

.ourClickBox .comSeacrh_input .searchBox input::placeholder {
    color: #C3C4C7;
    font-size: 16px;
    font-family: 'Gilory-SemiBold';
}

.redText {
    color: #b10000;
    font-family: 'Gilroy-Bold';
}

/* h2 {
    font-family: 'Segoe UI Emoji', 'Apple Color Emoji', 'Noto Color Emoji', sans-serif !important;
    font-size: 2em !important;

} */

/* .booking .bookingBox .bookLeftBox {
    margin-top: 50px;
} */

.cookie-modal {
    padding-left: 0 !important;
}

.cookie-modal .modal-dialog {
    max-width: 640px;
}

.cookie-modal .modal-content {
    border-radius: 16px;
    box-shadow: 5px 15px 20px 0px #00000040;
}

.cookie-modal .modal-body {
    padding: 30px 30px 20px;
}

.cookie-modal .first_box h5 {
    color: var(--dark-box);
    font-family: 'Manrope-Bold';
}

.cookie-modal .first_box p {
    color: #334155;
    font-family: 'Manrope-Regular';
    font-size: 12px;
}

.cookie-modal .modal-footer {
    justify-content: center;
    border: none;
    padding: 0px 30px 30px;
    gap: 15px;
}

.cookie-modal .modal-footer .btn_reject {
    font-size: 14px;
    color: var(--dark-box);
    border: 1px solid #F6E0A2;
    font-family: 'Manrope-SemiBold';
    box-shadow: none;
    outline: none;
    padding: 10px 25px;
    margin: 0;
    border-radius: 30px;
    white-space: nowrap;
}

.cookie-modal .modal-footer .btn_accept {
    font-size: 14px;
    color: var(--dark-box);
    border: 1px solid #ECBB33;
    background-color: #ECBB33;
    font-family: 'Manrope-SemiBold';
    box-shadow: none;
    outline: none;
    padding: 10px 25px;
    margin: 0;
    border-radius: 30px;
    white-space: nowrap;
}

.cookie-modal .privacy_overview {
    margin-top: 30px;
}

.cookie-modal .privacy_overview .overview_box {
    padding: 15px 20px;
    border: 2px solid #E2E8F0;
}

.cookie-modal .privacy_overview .overview_box:first-child {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
}

.cookie-modal .privacy_overview .overview_box:last-child {
    border-bottom-left-radius: 10px;
    border-bottom-right-radius: 10px;
}

.cookie-modal .privacy_overview .overview_box h6 {
    color: var(--dark-box);
    font-size: 14px;
    font-family: 'Manrope-Bold';
    margin-bottom: 10px;
}

.cookie-modal .privacy_overview .switch_view_box p {
    color: #334155;
    font-size: 14px;
    font-family: 'Manrope-Regular';
}

.cookie-modal .privacy_overview .switch_view_box {
    display: flex;
    align-items: center;
    gap: 20px;
}

.cookie-modal .switch_view_box .swicth_box .form-switch .form-check-input {
    background-color: #6E7191;
    border-color: #6E7191;
    min-height: 19px;
    width: 40px;
    box-shadow: none;
    outline: none;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) !important;
    margin-top: 0;
    cursor: pointer;
}

.cookie-modal .switch_view_box .swicth_box .form-switch .form-check-input:checked {
    background-color: #ECBB33;
    border-color: #ECBB33;
}

.mainContentBox .activityBox .showmoreBtn a {
    color: #b10000 !important;
}


/* ======= */

.accessibleBox .ourClickBox {
    display: flex;
    gap: 30px;
    padding: 10px 0;
    margin-bottom: 10px;
}

.accessibleBox .typecheck {
    padding-left: 0 !important;
}

.accessibleBox .typecheck .form-check-input {
    box-shadow: none !important;
    outline: none !important;
    margin-right: 10px;
    height: 20px;
    width: 20px;
    border: 2px solid var(--border-color);
}

.accessibleBox .typecheck .keyword-label {
    font-size: 16px;
    color: #11181C;
    font-family: 'Manrope-Bold';
}

.accessibleBox .typecheck .form-check-input:checked,
.form-radio-warning .form-check-input:checked {
    background-color: #F5A524;
    border-color: #F5A524;
}

.pickup_box ul {
    padding: 10px 0px 10px 30px;
}

.pickup_box ul li {
    list-style: disc;
    padding-left: 0px;
}

.pickup_box ul li p {
    font-size: 16px;
    color: #23252E;
    font-family: 'Manrope-Bold';
}

.pickup_box ul li span {
    color: #777777;
    display: inline;
}

.pickup_box .list-loader-container {
    margin-top: 10px !important;
    justify-content: unset !important;
    margin-left: 10% !important;
}

.pickup_box .listloader {
    width: 30px !important;
}

/* .pageSection2 .showMore {
    padding-right: 20px;
} */

/* #mobileSlider-1 .owl-stage-outer {
    overflow: visible;
    padding-right: 60px;
}

#mobileSlider-1 {
    padding-right: 40px;
}


#mobileSlider-1 .owl-item {
    transition: transform 0.3s;
}

#mobileSlider-1 .owl-item.active .item {
    transform: scale(1);
}

#mobileSlider-1 .owl-item .item {
    transform: scale(0.96);
} */

.react-calendar__tile:disabled {
    background-color: #f0f0f0;
    color: #ababab !important;
}

body.dark .notfoundLabel {
    background-color: #2c2c2c !important;
}

body.dark .pickup_box ul li p {
    font-size: 16px;
    color: var(--textP-color) !important;
    font-family: 'Manrope-Bold';
}

.redHeart {
    color: red !important;
}

body.dark .detasilTitle .detasilBox ul li a i.redHeart {
    color: red !important;
}

.bookRightBox .flatpickr-calendar:before,
.flatpickr-calendar:after {
    display: none !important;
}

body.dark .header-fav-icon a.active {
    background-color: var(--dark-box);

}

body.dark .header-fav-icon a {
    color: #CBD5E1 !important;
}

body.dark .dark_common_modal .modal-body,
body.dark .dark_common_modal .modal-content {
    background-color: var(--dark-box) !important;
}

body.dark .verification-modal.confirmation-modal .continueBox .continueBtn {
    border-color: #334155;
    background: transparent;
    color: #CBD5E1;
}

body.dark .verification-modal.confirmation-modal .modal-body h6,
body.dark .amountDetail .amountBox ul li p span,
body.dark .amountDetail .amountBox ul li p {
    color: #94A3B8;
}

body.dark .processing-title,
body.dark .processing-expire-note,
body.dark .dark_common_modal .modal-header .modal-title {
    color: #CBD5E1;
}

body.dark .amountDetail .amountBox ul li p:nth-child(even) {
    background-color: #2F2304;
}

body.dark .verification-modal .modal-body .register p {
    color: #94A3B8;
}

body.dark .getOtpBox .commonInput {
    background-color: var(--dark-box);
    border-color: #334155;
    color: #CBD5E1;
}

body.dark .dark_common_modal .commonGoldBtn,
body.dark .loginSec .loginpart .loginBox .loginBtn .btn-login {
    color: var(--dark-box) !important;
}

body.dark .commonLabel,
body.dark .loginSec .loginpart .loginBox .remember .checkBox .clickTo .keyword-label {
    color: #CBD5E1;
}

body.dark .commonInput {
    background-color: var(--dark-box);
    border-color: #334155;
    color: #CBD5E1;
}

body.dark .commonInput::placeholder,
body.dark .confirm_left .tab-pane .checkAndGo .clickTo .keyword-label {
    color: #94A3B8;
}

body.dark .loginSec .loginpart .loginBox {
    background-color: var(--dark-box);
}

.countBtn .disabled {
    pointer-events: none;
    opacity: 0.5;
    cursor: not-allowed;
}
body.dark .redColorText {
    color: #950606 !important;
}

.range-slider input[type=range] {
    position: absolute;
    pointer-events: all;
}

.range-slider input[type=range].on-top {
    z-index: 2;
}

.ourClickBox .dayContainer {
    min-width: 100% !important;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;
    text-align: center;
    width: 100%;
    max-width: 100%;
}
.ourClickBox .flatpickr-day {
    width: 100%;
    text-align: center;
    margin: 0 auto;
}
body.dark .ourClickBox .comSeacrh_input .searchBox.active input {
    background-color: var(--dark-box) !important;
        color: #CBD5E1 !important;
}

.confirm_left .paymentTab .nav-tabs .nav-link img {
    margin: 0 auto;
}
.bookNowLink{
    color: #ECBB33 !important;
    font-family: 'Gilroy-Bold';
    font-size: 16px;
    text-decoration: none;
    border: 1px solid #ECBB33;
    padding: 6px 15px;
    border-radius: 30px;
}
body.dark .bookNowLink{
    color: #b10000  !important;

}

.comon-tags-class p a{
    display: inline-block !important;
    margin: 0 5px !important;
}

.mobile_search_input {
    display: flex;
    align-items: center;
    gap: 10px;
}

a.smalllogo img {
    max-width: 45px !important;
}

/* @media (max-width:991px) {
    .header-part .searchBox {
        display: block !important;
    }
} */

img {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -webkit-user-drag: none;
  user-select: none;
}

@media (max-width:479px) {
    .filterpagereview .ti-header.source-Tripadvisor, 
    .filterpagereview .ti-header.ti-header-grid.source-all, 
    .filterpagereview .ti-header.ti-header-grid.source-Google {
        padding: 5px !important;
    }
}

.pageSection2 .Section2Box .travelBox .imgBox.skeleton::after{
    border-radius: 30px 30px 0px 0px !important;
}

.pageSection2 .Section2Box .travelBox .textBox ul .skeleton,
.pageSection2 .Section2Box .priceBox .priceListTag.skeleton, 
.pageSection2 .Section2Box .priceBox .listRating.skeleton {
    min-height: 30px;
    min-width: 80px;
}
.pageSection2 .Section2Box .container .sectionTitle.skeleton{
    min-height: 54px;
    min-width: 40px;
    max-width: 40%;
}`, "",{"version":3,"sources":["webpack://./src/assest/css/custom.css"],"names":[],"mappings":"AAAA;IACI,cAAc;IACd,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,eAAe;AACnB;;AAEA,KAAK;AACL;;IAEI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,oBAAoB;AACxB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,mBAAmB;IACnB,wBAAwB;IACxB,2BAA2B;IAC3B,yBAAyB;IACzB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA,WAAW;AACX;IACI,eAAe;IACf,QAAQ;IACR,OAAO;IACP,MAAM;IACN,SAAS;IACT,YAAY;IACZ,uBAAuB;IACvB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,sBAAsB;IACtB,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;;IAEI,yBAAyB;IACzB,kBAAkB;IAClB,6BAA6B;IAC7B,WAAW;IACX,YAAY;IAEZ,+CAA+C;AACnD;;AAYA;IACI;QACI,uBAAuB;IAC3B;;IAEA;QACI,yBAAyB;IAC7B;AACJ;;AAEA;;GAEG;;AAEH,gBAAgB;AAChB;IACI,oCAAoC;AACxC;;;;AAIA;IACI,mBAAmB;IACnB,sBAAsB;IACtB,uCAAuC;AAC3C;;;AAGA;;GAEG;AACH;IACI,uBAAuB;AAC3B;;AAEA;IACI;QACI,aAAa;QACb,UAAU;QACV,4BAA4B;IAChC;;IAEA;QACI,iBAAiB;QACjB,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;IACI;QACI,iBAAiB;QACjB,UAAU;QACV,wBAAwB;IAC5B;;IAEA;QACI,aAAa;QACb,UAAU;QACV,4BAA4B;IAChC;AACJ;;AAEA;;;IAGI,cAAc;IACd,2CAA2C;AAC/C;;AAEA;;;IAGI,yCAAyC;AAC7C;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,6DAA6D;IAC7D,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;IACjB,WAAW;IACX,YAAY;AAChB;;AAEA;;IAEI,kCAAkC;IAClC,uBAAuB;AAC3B;;;AAGA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA,qCAAqC;AACrC;;;;;;;;;;;;;;;;KAgBK;;AAEL,qCAAqC;AACrC;IACI,WAAW;IACX,eAAe;IACf,kBAAkB;IAClB;;0CAEsC;IACtC,4EAA4E;IAC5E,iCAAiC;AACrC;;AAEA;IACI;QACI;IACJ;AACJ;;AAEA;;GAEG;;AAEH;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,eAAe;AACnB;;AAEA;IACI,aAAa;AACjB;;AAEA,KAAK;AACL;;IAEI,wBAAwB;IACxB,oBAAoB;AACxB;;AAEA;;IAEI,0BAA0B;IAC1B,mBAAmB;IACnB,yBAAyB;IACzB,YAAY;AAChB;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,WAAW;AACf;;AAEA;;IAEI,yBAAyB;IACzB,0BAA0B;IAC1B,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,kBAAkB;IAClB,UAAU;IACV,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;IACR,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,wBAAwB;IACxB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;;;GAGG;AACH;;;;;;GAMG;AACH;;IAEI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;;AAE7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,6BAA6B;;AAEjC;;AAEA;;;IAGI,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,mBAAmB;IACnB,cAAc;IACd,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;GAEG;;AAEH;;;;;;;;;;;;;GAaG;AACH;IACI,aAAa;IACb,mBAAmB;IACnB,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,qBAAqB;AACzB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,eAAe;IACf,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,UAAU;AACd;;AAEA;IACI,mCAAmC;IACnC,0BAA0B;IAC1B,0BAA0B;AAC9B;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA,wBAAwB;AACxB;IACI,aAAa;AACjB;;AAEA,wCAAwC;AACxC;IACI,eAAe;IACf,wBAAwB;IACxB,qBAAqB;IACrB,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;;AAGA;IACI,wBAAwB;IACxB,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,8BAA8B;IAC9B,wBAAwB;AAC5B;;AAEA;IACI,yCAAyC;IACzC,eAAe;IACf,uBAAuB;AAC3B;;AAEA;IACI,4BAA4B;IAC5B,WAAW;IACX,kBAAkB;IAClB,uBAAuB;IACvB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,WAAW;AACf;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,UAAU;AACd;;AAEA;IACI,qCAAqC;AACzC;;AAEA;IACI,wBAAwB;IACxB,8BAA8B;IAC9B,oDAAoD;IACpD,wBAAwB;AAC5B;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;;IAEI,qDAAqD;AACzD;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;IACvB,uBAAuB;AAC3B;;AAEA;IACI,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;;;;;;;;;;;;GAaG;;AAEH;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;AACnB;;AAEA;;IAEI,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;;IAGI,wBAAwB;AAC5B;;AAEA;;GAEG;;AAEH;;;;;;;;;GASG;;AAEH;;;;;;;;GAQG;;AAEH;IACI,mDAAmD;IACnD,oBAAoB;AACxB;;AAEA;IACI,mDAAmD;IACnD,4BAA4B;IAC5B,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,mBAAmB;IACnB,mCAAmC;AACvC;;;AAGA;IACI,eAAe;AACnB;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,gCAAgC;IAChC,6BAA6B;AACjC;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;IAEI,8CAA8C;AAClD;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,2FAA2F;AAC/F;;AAEA;IACI,uFAAuF;IACvF,oFAAoF;;AAExF;;AAEA;IACI,uFAAuF;IACvF,oFAAoF;;AAExF;;AAEA;IACI,oBAAoB;IACpB,4BAA4B;IAC5B,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;IACzB,iBAAiB;AACrB;;AAEA;IACI,qBAAqB;AACzB;;;AAGA;IACI,oCAAoC;IACpC,6BAA6B;IAC7B,8BAA8B;IAC9B,yCAAyC;IACzC,cAAc;IACd,6BAA6B;IAC7B,eAAe;IACf,2BAA2B;AAC/B;;AAEA;IACI,uBAAuB;IACvB,2BAA2B;IAC3B,mBAAmB;IACnB,6BAA6B;AACjC;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,0BAA0B;IAC1B,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,wCAAwC;AAC5C;;AAEA;;;IAGI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,kDAAkD;IAClD,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,4CAA4C;AAChD;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,6BAA6B;AACjC;;AAEA;IACI,cAAc;IACd,eAAe;IACf,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;IAClB,kDAAkD;IAClD,mBAAmB;IACnB,aAAa;IACb,8BAA8B;IAC9B,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI,WAAW;IACX,2BAA2B;IAC3B,mCAAmC;IACnC,cAAc;IACd,kBAAkB;IAClB,iBAAiB;IACjB,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,mCAAmC;AACvC;;AAEA;IACI,0CAA0C;AAC9C;;AAEA;IACI,0BAA0B;IAC1B,aAAa;IACb,kDAAkD;IAClD,kCAAkC;IAClC,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;IACvB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI;QACI,YAAY;QACZ,WAAW;QACX,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;;QAEI,uBAAuB;QACvB,0BAA0B;IAC9B;AACJ;;;AAGA;IACI;QACI,4BAA4B;IAChC;AACJ;;AAEA;IACI,WAAW;IACX,cAAc;IACd,UAAU;IACV,WAAW;IACX,oCAAoC;IACpC,kBAAkB;IAClB,kBAAkB;IAClB,WAAW;IACX,SAAS;IACT,2BAA2B;AAC/B;;AAEA;IACI,oCAAoC;IACpC,yBAAyB;IACzB,oCAAoC;AACxC;;AAEA;IACI,oCAAoC;;AAExC;;AAEA;;;;GAIG;;AAEH;IACI,oCAAoC;AACxC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;GAEG;AACH;;IAEI,aAAa;;AAEjB;;AAEA;IACI,+BAA+B;;AAEnC;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,aAAa;IACb,oBAAoB;AACxB;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI;AACJ;;AAEA,WAAW;AACX;IACI,eAAe;IACf,6BAA6B;IAC7B,mBAAmB;IACnB,2CAA2C;IAC3C,gCAAgC;IAChC,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,2BAA2B;IAC3B,6CAA6C;AACjD;;AAEA;IACI,yBAAyB;IACzB,mBAAmB;IACnB,iDAAiD;IACjD,4BAA4B;AAChC;;AAEA;IACI,eAAe;IACf,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,mBAAmB;IACnB,aAAa;IACb,gBAAgB;IAChB,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,mBAAmB;IACnB,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,qBAAqB;IACrB,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,kCAAkC;AACtC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,WAAW;AACX;IACI,kBAAkB;IAClB,iBAAiB;IACjB,mBAAmB;IACnB,kBAAkB;IAClB,sBAAsB;IACtB,yBAAyB;;AAE7B;;AAEA,wCAAwC;AACxC;IACI,YAAY;IACZ,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,iBAAiB;IACjB,yIAAyI;IACzI,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,WAAW;IACX,YAAY;IACZ,mFAAmF;IACnF,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,kBAAkB;IAClB,UAAU;AACd;;AAEA,yBAAyB;AACzB;;IAEI,WAAW;IACX,kBAAkB;IAClB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,QAAQ;IACR,UAAU;IACV,2BAA2B;IAC3B,aAAa;IACb,cAAc;IACd,6BAA6B;IAC7B,gCAAgC;AACpC;;AAEA;IACI,QAAQ;IACR,WAAW;IACX,2BAA2B;IAC3B,eAAe;IACf,4BAA4B;IAC5B,+BAA+B;AACnC;;AAEA,gBAAgB;AAChB;IACI,kBAAkB;IAClB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,eAAe;IACf,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA,oBAAoB;AACpB;IACI,aAAa;IACb,8BAA8B;IAC9B,eAAe;IACf,kBAAkB;IAClB,WAAW;AACf;;AAEA;IACI,cAAc;IACd,iBAAiB;AACrB;;AAEA,iBAAiB;AACjB;IACI,eAAe;IACf,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,oCAAoC;IACpC,mBAAmB;IACnB,gBAAgB;IAChB,gBAAgB;IAChB,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,oBAAoB;IACpB,kBAAkB;IAClB,kBAAkB;IAClB,uBAAuB;IACvB,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,kBAAkB;IAClB,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,cAAc;AAClB;;AAEA;IACI,yBAAyB;IACzB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,2BAA2B;AAC/B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,oBAAoB;AACxB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,YAAY;IACZ,WAAW;AACf;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,YAAY;IACZ,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,QAAQ;AACZ;;AAEA;IACI,wBAAwB;IACxB,iBAAiB;IACjB,mBAAmB;IACnB,2BAA2B;IAC3B,gBAAgB;AACpB;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,0BAA0B;IAC1B,uBAAuB;AAC3B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,0BAA0B;IAC1B,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,wBAAwB;IACxB,2BAA2B;IAC3B,8BAA8B;IAC9B,6BAA6B;AACjC;;AAEA;IACI,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,mBAAmB;AACvB;;AAEA;IACI,6BAA6B;AACjC;;AAEA;;IAEI,2BAA2B;;AAE/B;;AAEA;IACI,oBAAoB;IACpB,qBAAqB;IACrB,4BAA4B;IAC5B,gBAAgB;IAChB,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,oCAAoC;IACpC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,2BAA2B;IAC3B,uBAAuB;IACvB,sBAAsB;IACtB,yBAAyB;IACzB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,0BAA0B;IAC1B,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,uBAAuB;IACvB,4BAA4B;IAC5B,8BAA8B;IAC9B,gDAAgD;AACpD;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,wCAAwC;AAC5C;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,oCAAoC;IACpC,wDAAwD;IACxD,8CAA8C;IAC9C,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,sBAAsB;IACtB,0BAA0B;IAC1B,YAAY;IACZ,wCAAwC;AAC5C;;AAEA;IACI,iCAAiC;IACjC,6BAA6B;IAC7B,8BAA8B;IAC9B,qBAAqB;AACzB;;AAEA;;GAEG;;AAEH;IACI,wBAAwB;IACxB,kDAAkD;AACtD;;AAEA;IACI,yBAAyB;IACzB,yCAAyC;IACzC,qCAAqC;IACrC,gCAAgC;IAChC,0BAA0B;AAC9B;;AAEA;IACI,iCAAiC;IACjC,yCAAyC;AAC7C;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;;IAEI,0CAA0C;IAC1C,6BAA6B;AACjC;;AAEA;;;IAGI,8BAA8B;AAClC;;AAEA;;;IAGI,6BAA6B;IAC7B,mBAAmB;IACnB,sBAAsB;IACtB,eAAe;IACf,yCAAyC;IACzC,0CAA0C;IAC1C,mBAAmB;AACvB;;AAEA;IACI,4BAA4B;AAChC;;AAEA;IACI,6BAA6B;IAC7B,cAAc;AAClB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,cAAc;IACd,0BAA0B;AAC9B;;AAEA;IACI,eAAe;IACf,cAAc;IACd,mBAAmB;IACnB,0BAA0B;AAC9B;;AAEA;IACI,cAAc;IACd,eAAe;IACf,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;IAChB,yBAAyB;IACzB,mBAAmB;AACvB;;AAEA;IACI,8BAA8B;IAC9B,wBAAwB;AAC5B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,kBAAkB;IAClB,WAAW;IACX,QAAQ;IACR,2BAA2B;IAC3B,wBAAwB;AAC5B;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;;;;GAIG;AACH;IACI,wBAAwB;;AAE5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,mBAAmB;IACnB,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,0CAA0C;AAC9C;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,2BAA2B;IAC3B,cAAc;AAClB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,aAAa;AACjB;;AAEA;IACI,yBAAyB;IACzB,aAAa;IACb,YAAY;;AAEhB;;AAEA;IACI,SAAS;AACb;;AAEA,KAAK;;AAEL;IACI,2CAA2C;IAC3C,iBAAiB;IACjB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,mDAAmD;IACnD,kBAAkB;IAClB,2BAA2B;AAC/B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,mBAAmB;IACnB,gDAAgD;AACpD;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mBAAmB;IACnB,cAAc;IACd,+BAA+B;AACnC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,8BAA8B;AAClC;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,cAAc;IACd,8BAA8B;AAClC;;AAEA,KAAK;;AAEL;IACI,kBAAkB;IAClB,QAAQ;IACR,QAAQ;IACR,cAAc;IACd,2BAA2B;IAC3B,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,6BAA6B;IAC7B,oBAAoB;AACxB;;AAEA;IACI,kBAAkB;IAClB,YAAY;IACZ,aAAa;IACb,yBAAyB;IACzB,mCAAmC;IACnC,mCAAmC;IACnC,2CAA2C;IAC3C,4BAA4B;IAC5B,8BAA8B;AAClC;;AAEA;IACI,uBAAuB;IACvB,wBAAwB;IACxB,sBAAsB;IACtB,uBAAuB;IACvB,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,0CAA0C;IAC1C,aAAa;IACb,WAAW;IACX,4BAA4B;;AAEhC;;AAEA;IACI,aAAa;IACb,WAAW;;AAEf;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,4BAA4B;IAC5B,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,cAAc;IACd,sCAAsC;AAC1C;;AAEA;IACI,cAAc;IACd,yCAAyC;AAC7C;;AAEA;IACI,aAAa;IACb,SAAS;AACb;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,mCAAmC;IACnC,0CAA0C;AAC9C;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,WAAW;IACX,mCAAmC;AACvC;;AAEA;IACI,gBAAgB;IAChB,aAAa;IACb,uBAAuB;IACvB,SAAS;AACb;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,6BAA6B;IAC7B,YAAY;IACZ,2BAA2B;IAC3B,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,cAAc;IACd,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,8BAA8B;AAClC;;AAEA;;IAEI,6BAA6B;AACjC;;AAEA;;IAEI,2BAA2B;;AAE/B;;AAEA;IACI,yBAAyB;IACzB,eAAe;IACf,WAAW;IACX,eAAe;IACf,YAAY;IACZ,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,yBAAyB;IACzB,wBAAwB;AAC5B;;AAEA;IACI,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;IACI,kCAAkC;AACtC;;AAEA;IACI,sBAAsB;IACtB,kBAAkB;AACtB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;IACjC,oBAAoB;AACxB;;AAEA;IACI,iBAAiB;IACjB,2BAA2B;AAC/B;;AAEA,KAAK;AACL,0CAA0C;AAC1C;;;;;;;IAOI,aAAa;AACjB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA,kDAAkD;AAClD;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,eAAe;IACf,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,SAAS;IACT,eAAe;AACnB;;AAEA;IACI,UAAU;IACV,kBAAkB;AACtB;;AAEA;IACI,UAAU;IACV,mBAAmB;AACvB;;AAEA;;;;;;GAMG;;AAEH;IACI,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,sBAAsB;IACtB,0BAA0B;AAC9B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,yBAAyB;IACzB,kBAAkB;IAClB,kDAAkD;AACtD;;AAEA;;IAEI,qBAAqB;IACrB,kBAAkB;IAClB,6BAA6B;AACjC;;AAEA;IACI,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;IAEI,2BAA2B;AAC/B;;AAEA;IACI,8BAA8B;AAClC;;AAEA;IACI,UAAU;IACV,2BAA2B;IAC3B,eAAe;IACf,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,+BAA+B;IAC/B,yBAAyB;;AAE7B;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,2BAA2B;IAC3B,eAAe;IACf,yBAAyB;AAC7B;;AAEA;IACI,wBAAwB;IACxB,6BAA6B;IAC7B,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,6BAA6B;IAC7B,oBAAoB;IACpB,gBAAgB;IAChB,qBAAqB;IACrB,wBAAwB;AAC5B;;AAEA;IACI,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;;;;IAII,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,4CAA4C;AAChD;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,WAAW;AACf;;;AAGA;IACI,kBAAkB;IAClB,cAAc;IACd,8BAA8B;IAC9B,6BAA6B;IAC7B,eAAe;IACf,kBAAkB;IAClB,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,cAAc;IACd,uBAAuB;IACvB,qBAAqB;IACrB,yBAAyB;IACzB,uBAAuB;IACvB,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;IAC3B,iBAAiB;IACjB,aAAa;IACb,WAAW;IACX,yBAAyB;IACzB,kBAAkB;AACtB;;AAEA;IACI,wBAAwB;AAC5B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,cAAc;AAClB;;AAEA;IACI,sBAAsB;IACtB,aAAa;AACjB;;AAEA;IACI,aAAa;AACjB;;;;AAIA;IACI;AACJ;;AAEA,KAAK;AACL;IACI,WAAW;IACX,yBAAyB;IACzB,eAAe;IACf,sBAAsB;AAC1B;;AAEA;;IAEI,sBAAsB;IACtB,oBAAoB;IACpB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,cAAc;IACd,yBAAyB;AAC7B;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA;IACI,cAAc;IACd,gBAAgB;IAChB,WAAW;IACX,yBAAyB;AAC7B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,iBAAiB;IACjB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,cAAc;AAClB;;AAEA,KAAK;;;AAGL;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,WAAW;AACf;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,kBAAkB;IAClB,cAAc;IACd,gBAAgB;IAChB,WAAW;AACf;;AAEA;;IAEI,8BAA8B;IAC9B,YAAY;IACZ,WAAW;IACX,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,QAAQ;IACR,2BAA2B;IAC3B,gBAAgB;IAChB,UAAU;IACV,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;AACpB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,UAAU;IACV,qCAAqC;IACrC,UAAU;IACV,WAAW;AACf;;AAEA;IACI,wBAAwB;IACxB,eAAe;AACnB;;AAEA;IACI,8BAA8B;IAC9B,YAAY;IACZ,gBAAgB;IAChB,YAAY;IACZ,UAAU;IACV,kBAAkB;IAClB,gBAAgB;IAChB,UAAU;IACV,aAAa;IACb,YAAY;AAChB;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,wBAAwB;IACxB,WAAW;IACX,qCAAqC;IACrC,UAAU;AACd;;AAEA;IACI,cAAc;IACd,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,cAAc;IACd,0BAA0B;AAC9B;;AAEA;;;;GAIG;;AAEH;;GAEG;;AAEH;IACI,0BAA0B;AAC9B;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,uCAAuC;AAC3C;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,8BAA8B;IAC9B,eAAe;AACnB;;AAEA;IACI,uBAAuB;IACvB,YAAY;IACZ,sBAAsB;IACtB,SAAS;AACb;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,+BAA+B;IAC/B,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,sBAAsB;IACtB,yBAAyB;IACzB,yBAAyB;IACzB,+BAA+B;IAC/B,gBAAgB;IAChB,aAAa;IACb,kBAAkB;IAClB,SAAS;IACT,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;IAClB,yBAAyB;AAC7B;;AAEA;IACI,4BAA4B;IAC5B,6BAA6B;AACjC;;AAEA;IACI,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,2BAA2B;IAC3B,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;IACrB,gBAAgB;IAChB,WAAW;IACX,gBAAgB;IAChB,aAAa;IACb,oEAA2D;IAC3D,aAAa;IACb,eAAe;AACnB;;AAEA;IACI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,yBAAyB;AAC7B;;;AAGA,YAAY;;AAEZ;IACI,aAAa;IACb,SAAS;IACT,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,2BAA2B;IAC3B,wBAAwB;IACxB,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,qCAAqC;AACzC;;AAEA;IACI,eAAe;IACf,cAAc;IACd,2BAA2B;AAC/B;;AAEA;;IAEI,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,gBAAgB;IAChB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,2BAA2B;AAC/B;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,2BAA2B;IAC3B,iCAAiC;IACjC,2BAA2B;AAC/B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;;GAEG;;AAEH;;;;;;;;;;;;;;;;;;;;GAoBG;;AAEH;IACI,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA;IACI,oCAAoC;AACxC;;AAEA;IACI,eAAe;IACf,oCAAoC;IACpC,2BAA2B;AAC/B;;AAEA;IACI,qBAAqB;AACzB;;AAEA;IACI,qBAAqB;AACzB;;AAEA;;IAEI,wBAAwB;AAC5B;;AAEA;IACI,iCAAiC;;AAErC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;;IAEI,4CAA4C;AAChD;;AAEA;IACI,qBAAqB;IACrB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;;;IAGI,cAAc;AAClB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iCAAiC;IACjC,qBAAqB;IACrB,cAAc;AAClB;;AAEA;;IAEI,iCAAiC;AACrC;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,iCAAiC;IACjC,qBAAqB;IACrB,cAAc;AAClB;;AAEA;;IAEI,cAAc;AAClB;;AAEA;IACI,iCAAiC;AACrC;;AAEA;IACI,oBAAoB;IACpB,YAAY;IACZ,mBAAmB;AACvB;AACA;IACI,yBAAyB;AAC7B;;AAEA;IACI,kBAAkB;IAClB,mBAAmB;AACvB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,0BAA0B;IAC1B,aAAa;IACb,kDAAkD;IAClD,kBAAkB;IAClB,WAAW;IACX,eAAe;AACnB;AACA;IACI,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;AACA;IACI,4CAA4C;QACxC,yBAAyB;AACjC;;AAEA;IACI,cAAc;AAClB;AACA;IACI,yBAAyB;IACzB,0BAA0B;IAC1B,eAAe;IACf,qBAAqB;IACrB,yBAAyB;IACzB,iBAAiB;IACjB,mBAAmB;AACvB;AACA;IACI,0BAA0B;;AAE9B;;AAEA;IACI,gCAAgC;IAChC,wBAAwB;AAC5B;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;;;GAIG;;AAEH;EACE,2BAA2B;EAC3B,yBAAyB;EACzB,uBAAuB;EACvB,iBAAiB;AACnB;;AAEA;IACI;;;QAGI,uBAAuB;IAC3B;AACJ;;AAEA;IACI,2CAA2C;AAC/C;;AAEA;;;IAGI,gBAAgB;IAChB,eAAe;AACnB;AACA;IACI,gBAAgB;IAChB,eAAe;IACf,cAAc;AAClB","sourcesContent":[".cus-err {\n    color: #D8000C;\n    position: absolute;\n    left: 5px;\n    bottom: 0px;\n    font-size: 13px;\n}\n\n/*  */\n.iti,\n.iti--allow-dropdown {\n    width: 100%;\n    margin-bottom: 20px;\n}\n\n.reg-g-captcha-main {\n    position: relative;\n    padding: 10px 0 20px;\n}\n\n.iti__tel-input {\n    width: 100%;\n    padding: 10px 15px;\n    border-radius: 12px;\n    outline: none !important;\n    box-shadow: none !important;\n    border: 2px solid #E6E8EC;\n    /* margin-bottom: 15px; */\n    margin-bottom: 20px;\n}\n\n/* Loader */\n.preloader {\n    position: fixed;\n    right: 0;\n    left: 0;\n    top: 0;\n    bottom: 0;\n    opacity: 0.5;\n    background-color: white;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-direction: column;\n    z-index: 2000 !important;\n}\n\n.preloader span {\n    text-transform: uppercase;\n    font-size: 12px;\n    letter-spacing: 2px;\n    margin-top: 15px;\n}\n\n.preloader .preloader-icon,\n.inside-loader .preloader-icon {\n    border: 2px solid #eeeeee;\n    border-radius: 50%;\n    border-top: 2px solid #E3BD3E;\n    width: 70px;\n    height: 70px;\n    -webkit-animation: spin 0.5s linear infinite !important;\n    animation: spin 0.5s linear infinite !important;\n}\n\n@-webkit-keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes spin {\n    0% {\n        transform: rotate(0deg);\n    }\n\n    100% {\n        transform: rotate(360deg);\n    }\n}\n\n/* .no-scroll {\n    overflow: hidden;\n} */\n\n/* Loader Ends */\n.commonInput.greenSpan {\n    border: 2px solid #2ABC30 !important;\n}\n\n\n\n.adultDropBox {\n    /* max-height: 0; */\n    /* overflow: hidden; */\n    transition: max-height 0.2s ease-in-out;\n}\n\n\n/* .adultDropBox {\n    display: block;\n} */\n.bookRightBox .selectDate .multyDrop .adultDropBox ul {\n    background-color: white;\n}\n\n@keyframes slideDown {\n    from {\n        max-height: 0;\n        opacity: 0;\n        transform: translateY(-20px);\n    }\n\n    to {\n        max-height: 150px;\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n@keyframes slideUp {\n    from {\n        max-height: 150px;\n        opacity: 1;\n        transform: translateY(0);\n    }\n\n    to {\n        max-height: 0;\n        opacity: 0;\n        transform: translateY(-20px);\n    }\n}\n\n.adultDropBox.open,\n.dateDropBox.open,\n.timeDropBox.open {\n    display: block;\n    animation: slideDown 0.2s ease-out forwards;\n}\n\n.adultDropBox.close,\n.dateDropBox.close,\n.timeDropBox.close {\n    animation: slideUp 0.2s ease-out forwards;\n}\n\n.flatpickr-input {\n    padding: 20px 20px;\n    border-radius: 15px;\n    background: white;\n}\n\n.ourClickBox.accordion-body .flatpickr-input {\n    /* box-shadow: 0px 0px 10px var(--border-color) !important; */\n    box-shadow: none !important;\n}\n\nbody.dark .flatpickr-input {\n    background-color: #1f1f1f;\n}\n\n.detailsSlider .sliderImg {\n    height: 475px;\n}\n\n.detailsSlider .sliderImg img {\n    object-fit: cover;\n    width: 100%;\n    height: 100%;\n}\n\n.owl-next:hover,\n.owl-prev:hover {\n    background: transparent !important;\n    opacity: 0.5 !important;\n}\n\n\n.pageSection2 .Section2Box .travelBox {\n    box-shadow: none !important;\n    transition: 0.3s;\n}\n\n.pageSection2 .Section2Box .travelBox:hover {\n    box-shadow: 0px 0px 30px #dbdbdb !important;\n}\n\n/* HTML: <div class=\"loader\"></div> */\n/* .listloader {\n    width: 60px;\n    aspect-ratio: 2;\n    --_g: no-repeat radial-gradient(circle closest-side,#000 90%,#0000);\n    background: \n      var(--_g) 0%   50%,\n      var(--_g) 50%  50%,\n      var(--_g) 100% 50%;\n    background-size: calc(100%/3) 50%;\n    animation: l3 1s infinite linear;\n  }\n  @keyframes l3 {\n      20%{background-position:0%   0%, 50%  50%,100%  50%}\n      40%{background-position:0% 100%, 50%   0%,100%  50%}\n      60%{background-position:0%  50%, 50% 100%,100%   0%}\n      80%{background-position:0%  50%, 50%  50%,100% 100%}\n  } */\n\n/* HTML: <div class=\"loader\"></div> */\n.listloader {\n    width: 50px;\n    aspect-ratio: 1;\n    border-radius: 50%;\n    background:\n        radial-gradient(farthest-side, #E3BD3E 94%, #0000) top/8px 8px no-repeat,\n        conic-gradient(#0000 30%, #E3BD3E);\n    -webkit-mask: radial-gradient(farthest-side, #0000 calc(100% - 8px), #000 0);\n    animation: l13 1s infinite linear;\n}\n\n@keyframes l13 {\n    100% {\n        transform: rotate(1turn)\n    }\n}\n\n/* .paginationBox .pagination .page-item .page-link {\n    border: unset !important;\n} */\n\n.exploreTour .pagenext {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    padding: 0 10px;\n}\n\n.exploreTour .ourTourBox .leftImg img {\n    height: 250px;\n}\n\n/*  */\n.iti,\n.ourdetailProfile.profileImport .iti {\n    display: flex !important;\n    gap: 10px !important;\n}\n\n.iti__country-container,\n.ourdetailProfile.profileImport .iti__country-container {\n    position: unset !important;\n    border-radius: 12px;\n    border: 2px solid #E6E8EC;\n    width: 170px;\n}\n\n.iti__tel-input,\n.ourdetailProfile.profileImport .iti__tel-input {\n    padding-left: 10px !important;\n}\n\n.iti__selected-country,\n.ourdetailProfile.profileImport .iti__selected-country {\n    width: 100%;\n}\n\n.iti__arrow,\n.ourdetailProfile.profileImport .iti__arrow {\n    border-left: 0 !important;\n    border-right: 0 !important;\n    margin-left: 0 !important;\n}\n\n.iti__arrow::after {\n    content: '\\f078';\n    font-family: 'fontawesome';\n    position: absolute;\n    right: 4px;\n    font-size: 11px;\n    margin-left: 10px;\n    height: 25px;\n    width: 25px;\n    border: 2px solid #E6E8EC;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    top: 50%;\n    transform: translateY(-50%);\n}\n\n.iti .iti__selected-dial-code {\n    margin-left: 3px !important;\n}\n\n.iti__selected-country-primary {\n    padding-right: 0 !important;\n}\n\n.iti__selected-country-primary:hover {\n    background-color: transparent !important;\n}\n\n.iti__search-input {\n    outline: none !important;\n    border: 2px solid #E6E8EC;\n    padding: 10px 15px;\n    border-radius: 12px;\n}\n\n/* .req-sym {\n    color: #fa5c7c;\n    margin-left: 0.3rem;\n} */\n/* .companyProfilePage .boxCard{\n    position: relative ;\n\n}\n.companyProfilePage .cus-err{\n    bottom: -20px !important;\n} */\nbody.dark .activityhead .backBox a,\nbody.dark .activityhead .backBox a i {\n    color: #B1B5C3 !important;\n}\n\nbody.dark .rightTabcontent .pagenext .pageList p {\n    color: #B1B5C3 !important;\n\n}\n\nbody.dark .filtersearchbtn {\n    color: #B1B5C3 !important;\n}\n\n.mainDetailsBox .ourTourBox {\n    box-shadow: none !important;\n    transition: 0.3s;\n}\n\n.mainDetailsBox .ourTourBox:hover {\n    box-shadow: 0px 0px 30px #dbdbdb !important;\n}\n\n.filterpage .flatpickr-day.selected {\n    background-color: #E3BD3E !important;\n    color: #23262F !important;\n}\n\n.prevMonthDay {\n    visibility: hidden !important;\n}\n\n.nextMonthDay {\n    visibility: hidden !important;\n\n}\n\n.innerFormBox .box-box,\n.boxFull,\n.fillDetails .nameBox .box-box {\n    position: relative;\n}\n\n.commonLabel {\n    width: 100%;\n    padding-bottom: 5px;\n    color: #292929;\n    font-family: 'Manrope-Regular';\n}\n\n.full_description_text {\n    font-family: 'Manrope-Regular';\n}\n\n/* .full_description_text  {\n    font-family: sans-serif, Arial, Verdana, \"Trebuchet MS\";\n} */\n\n/* \n.full_description_text p {\n    font-size: unset;\n    color: unset;\n}\n\n.full_description_text ul {\n    list-style: unset !important;\n    margin: unset !important;\n    padding: unset !important;\n    padding-left: 2rem !important;\n    margin-top: 0 !important;\n    margin-bottom: 1rem !important;\n} */\n.full_description_text p {\n    margin-top: 0;\n    margin-bottom: 1rem;\n    font-size: 1rem;\n    line-height: 1.5;\n    color: #212529;\n}\n\n.full_description_text ul {\n    padding-left: 2rem;\n    margin-top: 0;\n    margin-bottom: 1rem;\n    list-style-type: disc;\n}\n\n.full_description_text ol {\n    padding-left: 2rem;\n    margin-top: 0;\n    margin-bottom: 1rem;\n    list-style-type: decimal;\n}\n\n.full_description_text li {\n    margin-bottom: 0.5rem;\n}\n\n.full_description_text h1 {\n    margin-top: 0;\n    margin-bottom: 0.5rem;\n    font-size: 2.5rem;\n    font-weight: 500;\n    line-height: 1.2;\n}\n\n.full_description_text h2 {\n    margin-top: 0;\n    margin-bottom: 0.5rem;\n    font-size: 2rem;\n    font-weight: 500;\n    line-height: 1.2;\n}\n\n.full_description_text h3 {\n    margin-top: 0;\n    margin-bottom: 0.5rem;\n    font-size: 1.75rem;\n    font-weight: 500;\n    line-height: 1.2;\n}\n\n.full_description_text h4 {\n    margin-top: 0;\n    margin-bottom: 0.5rem;\n    font-size: 1.5rem;\n    font-weight: 500;\n    line-height: 1.2;\n}\n\n.full_description_text h5 {\n    margin-top: 0;\n    margin-bottom: 0.5rem;\n    font-size: 1.25rem;\n    font-weight: 500;\n    line-height: 1.2;\n}\n\n.full_description_text h6 {\n    margin-top: 0;\n    margin-bottom: 0.5rem;\n    font-size: 1rem;\n    font-weight: 500;\n    line-height: 1.2;\n}\n\n.full_description_text div {\n    font-size: 1rem;\n    line-height: 1.5;\n    color: #212529;\n}\n\n.typeBox .sendBtn .crossBtn {\n    background-color: #E2E8F0;\n}\n\n.typeBox .search-key,\nheader .header-box .search-key {\n    min-height: 100px;\n}\n\n.detasilBox.typeBox {\n    background: none;\n    padding: 0;\n}\n\n.typeBox .search-key ul h6 i {\n    color: var(--gold-color) !important;\n    position: unset !important;\n    transform: none !important;\n}\n\n.dropDownLoc {\n    z-index: 999;\n}\n\n.updateImg {\n    position: relative;\n    /* display: inline-block; */\n}\n\n/* Hide the file input */\n#avatarInput {\n    display: none;\n}\n\n/* Style the label as a button or link */\n.custom-file-upload {\n    cursor: pointer;\n    color: var(--gold-color);\n    text-decoration: none;\n    /* font-size: 14px; */\n    display: inline-flex;\n    align-items: center;\n}\n\n.custom-file-upload i {\n    margin-right: 5px;\n}\n\n\n.rightProfile .rightProfileMain .userImgBox .updateImg label {\n    color: var(--gold-color);\n    font-family: 'Manrope-SemiBold';\n    margin-top: 10px;\n}\n\n.commonGoldBtn {\n    background-color: #E3BD3E !important;\n}\n\n.flatpickr-day.selected {\n    background-color: #E3BD3E !important;\n    color: #23262F !important;\n    background: #E3BD3E !important;\n    border: unset !important;\n}\n\n.flatpickr-day {\n    font-family: 'Gilory-SemiBold' !important;\n    font-size: 15px;\n    border: none !important;\n}\n\n.commonInputSecond.flatpickr-input {\n    box-shadow: unset !important;\n    z-index: 55;\n    position: relative;\n    background: transparent;\n    padding-left: 40px;\n}\n\n.rightProfileMain .cus-err {\n    bottom: -20px !important;\n}\n\n.phoneBox .cus-err {\n    bottom: 0px !important;\n}\n\n.formHeaderTitle {\n    display: flex;\n    align-items: center;\n}\n\n.header-part .searchBox {\n    display: none !important;\n}\n\n.header-part .searchBox.visible {\n    display: block !important;\n}\n\n.bokunDropBox.custom-cal .iconDown {\n    height: 35px;\n    width: 35px;\n    border: 2px solid #E6E8EC;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    right: 10px;\n}\n\n.bokunDropBox.custom-cal .bi-calendar-week-fill {\n    color: #64748b;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    left: 10px;\n}\n\n.profileImport .userPersonaldet .toptitle h5 {\n    color: rgba(35, 38, 47, 1) !important;\n}\n\n.iti__country {\n    display: flex !important;\n    align-items: center !important;\n    padding: 8px var(--iti-spacer-horizontal) !important;\n    outline: none !important;\n}\n\n.iti__dial-code {\n    color: var(--iti-dialcode-color) !important;\n}\n\n.iti__country-list .iti__flag,\n.iti__country-name {\n    margin-right: var(--iti-spacer-horizontal) !important;\n}\n\n.iti__country-name,\n.iti__dial-code {\n    font-size: 13px !important;\n}\n\n.rightProfileMain .iti--inline-dropdown .iti__dropdown-content {\n    z-index: 999 !important;\n    width: 240px !important;\n}\n\n.userAc {\n    display: block !important;\n    z-index: 99;\n}\n\n.rightProfile .rightProfileMain .userPersonaldet {\n    margin-bottom: 100px;\n}\n\n.ti-widget-header {\n    padding: 0 !important;\n}\n\n/* .ti-load-more-reviews-container .ti-load-more-reviews-button {\n    color: var(--text-black) !important;\n    border: 2px solid #E6E8EC !important;\n    font-size: 16px !important;\n    padding: 8px 15px !important;\n    box-shadow: none !important;\n    border-radius: 30px !important;\n    font-family: 'Gilroy-Bold' !important;\n    width: 100% !important;\n    border-top-width: 2px !important;\n    border-bottom-width: 2px !important;\n    border-left-width: 2px !important;\n    border-right-width: 2px !important;\n} */\n\n.pageSection2 .Section2Box .priceBox {\n    align-items: center;\n}\n\n.pageSection2 .Section2Box .priceBox .priceListTag h5 {\n    font-size: 16px;\n}\n\n.pageSection2 .Section2Box .priceBox .priceListTag,\n.pageSection2 .Section2Box .priceBox .listRating {\n    width: calc(50% - 5px);\n}\n\n.pageSection2 .Section2Box .priceBox .listRating .ti-header {\n    padding: 0 !important;\n}\n\n.filterpagereview .ti-header.source-Tripadvisor,\n.filterpagereview .ti-header.ti-header-grid.source-all,\n.filterpagereview .ti-header.ti-header-grid.source-Google {\n    padding: 10px !important;\n}\n\n/* .full_description_text_activity a {\n    all: revert !important;\n} */\n\n/* .full_description_text_activity {\n    overflow: hidden;\n    display: -webkit-box;\n    -webkit-line-clamp: 3; \n    -webkit-box-orient: vertical;\n}\n\n.full_description_text_activity.expanded {\n    -webkit-line-clamp: unset; \n} */\n\n/* .full_description_text_activity {\n    max-height: 70px;\n    overflow: hidden;\n    transition: max-height 0.3s ease-in-out;\n}\n\n.full_description_text_activity.expanded {\n    max-height: 100%;\n} */\n\n.dropDownLoc {\n    background-color: rgba(253, 253, 253, 1) !important;\n    top: 40px !important;\n}\n\n.dropDownLoc li.newdropOpen ul.innerNewDrop {\n    background-color: rgba(253, 253, 253, 1) !important;\n    max-height: 340px !important;\n    overflow-y: auto;\n}\n\n.dropDownLoc li.newdropOpen ul.innerNewDrop::-webkit-scrollbar-track {\n    border-radius: 8px;\n    background-color: #f5f5f0;\n}\n\n.dropDownLoc li.newdropOpen ul.innerNewDrop::-webkit-scrollbar {\n    width: 4px;\n    background-color: #f5f5f0;\n}\n\n.dropDownLoc li.newdropOpen ul.innerNewDrop::-webkit-scrollbar-thumb {\n    border-radius: 10px;\n    background-color: var(--gold-color);\n}\n\n\nheader .header-box .logoBox .locationBox {\n    padding: 12px 0;\n}\n\n.dropDownLoc li a:hover {\n    background-color: rgba(253, 247, 232, 1);\n}\n\nheader .header-box .logoBox .locationBox a.active {\n    color: var(--gold-color);\n}\n\nheader .header-box .logoBox .locationBox a.active i {\n    transition: 0.2s all linear;\n}\n\nheader .header-box .logoBox .locationBox a.active i {\n    transform: rotate(180deg);\n}\n\n\n.mainBanner .bannerBox .bannerText.homepagebanner {\n    max-width: 600px;\n    margin: 0 auto;\n}\n\n.mainBanner .bannerBox .bannerText.homepagebanner .sliderText p {\n    margin-bottom: 0 !important;\n}\n\n.mainBanner .bannerBox .bannerText.homepagebanner .sliderText h2 {\n    font-size: 50px;\n}\n\n.suggetionRecord {\n    border-bottom: 1px solid #F1F5F9;\n    margin-bottom: 0px !important;\n}\n\n.mainBanner {\n    min-height: 490px;\n}\n\n.pageSection2 .Section2Box .priceBox {\n    min-height: 57px;\n}\n\n.typeBox .search-key,\nheader .header-box .menuBox .search-key {\n    box-shadow: 0px 10px 20px #00000026 !important;\n}\n\n.listingld-label {\n    font-size: 16px;\n    font-weight: bold;\n    color: #e3bd3e;\n}\n\n.mainBanner::after {\n    background: linear-gradient(0deg, rgba(0, 0, 0, 0.35) 0%, rgba(0, 0, 0, 0) 100%) !important;\n}\n\n.gallery .galleryPart .galleryBox .imgGridBox::after {\n    /* background: linear-gradient(0deg, rgb(0 0 0 / 35%) 0%, rgb(253 253 253 / 0%) 55%); */\n    background: linear-gradient(0deg, rgba(0, 0, 0, 0.35) 0%, rgb(253 253 253 / 0%) 55%);\n\n}\n\n.tourStyle .tourStylepart .tourBox .tourGallery .imgBox::after {\n    /* background: linear-gradient(0deg, rgb(0 0 0 / 35%) 0%, rgb(253 253 253 / 0%) 55%); */\n    background: linear-gradient(0deg, rgba(0, 0, 0, 0.35) 0%, rgb(253 253 253 / 0%) 55%);\n\n}\n\n#full_description_text_activity {\n    display: -webkit-box;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    transition: all 0.3s ease-in-out;\n}\n\n#full_description_text_activity.collapsed {\n    -webkit-line-clamp: 6;\n}\n\n#full_description_text_activity.expanded {\n    -webkit-line-clamp: unset;\n    overflow: visible;\n}\n\n.exploreTour .ourTourBox.skeleton::after {\n    z-index: 9 !important;\n}\n\n\n.selectDetails .accordion-item .accordion-button {\n    border: 2px solid #E6E8EC !important;\n    padding: 10px 20px !important;\n    border-radius: 15px !important;\n    background: var(--white-color) !important;\n    color: #777777;\n    font-family: 'Poppins-Medium';\n    font-size: 18px;\n    box-shadow: none !important;\n}\n\n.selectDetails .accordion-flush .accordion-item {\n    border: none !important;\n    box-shadow: none !important;\n    margin-bottom: 15px;\n    background-color: transparent;\n}\n\n.selectDetails .accordion-flush .accordion-body {\n    padding: 0 !important;\n}\n\n.selectDetails .accordion-item .accordion-button i {\n    color: #292D32;\n    margin-right: 10px;\n}\n\n.selectDetails .accordion-item .accordion-button::after {\n    content: '\\f078';\n    font-family: 'fontawesome';\n    background-image: none;\n    border: 2px solid #E6E8EC;\n    border-radius: 50%;\n    height: 35px;\n    width: 35px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.selectDetails .accordion-flush .accordion-item:hover {\n    background-color: transparent !important;\n}\n\n.adultDropBox,\n.timeDropBox,\n.dateDropBox {\n    display: block;\n    position: unset;\n}\n\n.bookRightBox .adultDropBox ul {\n    padding: 20px 20px;\n    /* box-shadow: 0px 0px 10px var(--border-color); */\n    border-radius: 15px;\n}\n\n.bookRightBox .adultDropBox ul li:not(:last-child) {\n    padding-bottom: 10px;\n    margin-bottom: 15px;\n    border-bottom: 1px solid var(--border-color);\n}\n\n.bookRightBox .adultDropBox ul li {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n.bookRightBox .adultDropBox ul li .adultage h6 {\n    font-size: 18px;\n    font-family: 'Gilory-SemiBold';\n}\n\n.bookRightBox .adultDropBox ul li .adultage span {\n    font-size: 14px;\n    color: var(--input-color);\n    font-family: 'Gilroy-Regular';\n}\n\n.bookRightBox .adultDropBox ul li .countBtn i {\n    color: #83889B;\n    font-size: 25px;\n    vertical-align: middle;\n    cursor: pointer;\n}\n\n.bookRightBox .adultDropBox ul li .countBtn span {\n    font-size: 18px;\n    padding: 0 20px;\n    color: #83889B;\n}\n\n.bookRightBox .timeDropBox ul {\n    background: #FCFCFD;\n    padding: 20px 20px;\n    /* box-shadow: 0px 0px 10px var(--border-color); */\n    border-radius: 12px;\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    text-align: center;\n    gap: 10px;\n}\n\n.bookRightBox .timeDropBox ul li a {\n    width: 100%;\n    background-color: #E3BD3E1A;\n    border: 1px solid var(--gold-color);\n    color: #2C2F3A;\n    border-radius: 5px;\n    padding: 10px 0px;\n    font-family: 'Gilory-SemiBold';\n    transition: 0.3s;\n}\n\n.bookRightBox .timeDropBox ul li a:hover {\n    background-color: var(--gold-color);\n}\n\n.selectDetails .accordion-flush .accordion-button:not(.collapsed) {\n    border-color: var(--gold-color) !important;\n}\n\n.selectDetails .ourClickBox .dayContainer {\n    min-width: 100% !important;\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;\n    justify-content: center !important;\n    text-align: center !important;\n    margin: 0 auto;\n}\n\n.selectDetails .ourClickBox .flatpickr-day.today:hover {\n    color: #393939 !important;\n}\n\n.flatpickr-day.today:hover {\n    color: #393939 !important;\n}\n\n.flatpickr-months .flatpickr-prev-month:hover svg,\n.flatpickr-months .flatpickr-next-month:hover svg {\n    fill: #FFD166 !important;\n}\n\n.selectDetails .ourClickBox .flatpickr-day {\n    max-width: 38px !important;\n    height: 38px !important;\n    width: 38px;\n    margin: 0 auto 8px;\n}\n\n@media (max-width:575px) {\n    .selectDetails .accordion-item .accordion-button::after {\n        height: 30px;\n        width: 30px;\n        font-size: 16px;\n    }\n\n    .selectDetails .accordion-item .accordion-button {\n        font-size: 16px;\n    }\n\n    .selectDetails .ourClickBox .flatpickr-monthDropdown-months,\n    .selectDetails .ourClickBox .numInput.cur-year {\n        width: 100px !important;\n        font-size: 16px !important;\n    }\n}\n\n\n@media (max-width:350px) {\n    .selectDetails .ourClickBox .flatpickr-input {\n        padding: 20px 0px !important;\n    }\n}\n\n.bookable-date::after {\n    content: \"\";\n    display: block;\n    width: 5px;\n    height: 5px;\n    background-color: #ECBB33 !important;\n    border-radius: 50%;\n    position: absolute;\n    bottom: 5px;\n    left: 50%;\n    transform: translateX(-50%);\n}\n\n.available-date {\n    background-color: #FDF7E8 !important;\n    color: #334155 !important;\n    /* border-radius: 50% !important;  */\n}\n\n.flatpickr-day.selected.bookable-date::after {\n    background-color: #44444F !important;\n\n}\n\n/* .ourClickBox .flatpickr-day.today {\n    border: 1px solid  !important;\n    border-color: #959ea9 !important;\n    background-color: unset !important;\n} */\n\n.selectDetails .ourClickBox .flatpickr-day:hover {\n    background-color: #e6e6e6 !important;\n}\n\n.selectDetails .ourClickBox .flatpickr-day.available-date:hover {\n    background-color: #e3bc3e29 !important;\n}\n\n.selectDetails .ourClickBox .flatpickr-day.selected:hover {\n    background: #E3BD3E !important;\n}\n\n/* .selectDetails .ourClickBox .flatpickr-day.bookable-date:hover {\n    background-color: #FDF7E8 !important;\n} */\n.selectDetails .ourClickBox .numInputWrapper .arrowDown,\n.selectDetails .ourClickBox .numInputWrapper .arrowUp {\n    display: none;\n\n}\n\n.selectDetails .ourClickBox .numInputWrapper .cur-year {\n    pointer-events: none !important;\n\n}\n\n.full_description_text img {\n    max-width: 100% !important;\n    height: auto !important;\n}\n\n.mainBanner {\n    margin: unset;\n    border-radius: unset;\n}\n\n.mainBanner::after {\n    border-radius: unset;\n}\n\n.selectDetails .ourClickBox .flatpickr-day.today {\n    background-color: unset\n}\n\n/* Rates  */\n.rate-card {\n    cursor: pointer;\n    border: 2px solid transparent;\n    border-radius: 16px;\n    box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.1);\n    transition: all 0.3s ease-in-out;\n    background: #fff;\n    padding: 20px;\n    position: relative;\n    overflow: hidden;\n    text-align: left;\n}\n\n.rate-card:hover {\n    transform: translateY(-5px);\n    box-shadow: 0px 10px 25px rgba(0, 0, 0, 0.15);\n}\n\n.rate-card.selected {\n    border: 2px solid #e3bd3e;\n    background: #fff9e6;\n    box-shadow: 0px 10px 25px rgba(227, 189, 62, 0.4);\n    /* transform: scale(1.03); */\n}\n\n.badge-selected {\n    font-size: 14px;\n    background: #e3bd3e;\n    color: #fff;\n    padding: 6px 12px;\n    border-radius: 20px;\n    display: none;\n    font-weight: 600;\n    align-items: center;\n    gap: 2px;\n}\n\n.rate-card.selected .badge-selected {\n    display: inline-flex;\n}\n\n.rate-header {\n    font-size: 18px;\n    font-weight: 600;\n    color: #333;\n    margin-bottom: 10px;\n    width: 100%;\n    max-width: 80%;\n}\n\n.divider {\n    height: 1px;\n    background: #ddd;\n    margin: 12px 0;\n}\n\n.policy {\n    display: flex;\n    align-items: baseline;\n    font-size: 14px;\n    color: #555;\n    margin-bottom: 8px;\n}\n\n.policy i {\n    color: #e3bd3e;\n    margin-right: 8px;\n}\n\n.price {\n    font-size: 24px;\n    font-weight: bold;\n    color: #e3bd3e !important;\n    position: absolute;\n    bottom: 15px;\n    right: 15px;\n    transition: color 0.3s ease-in-out;\n}\n\n.rate-card.selected .price {\n    color: #b29730 !important;\n}\n\n/* Ticket */\n.ticket {\n    /* width: 450px; */\n    background: white;\n    border-radius: 16px;\n    position: relative;\n    /* overflow: hidden; */\n    border: 2px solid #f5f5f5;\n\n}\n\n/* Ticket Header with Gradient Overlay */\n.ticket-header {\n    height: 75px;\n    position: relative;\n    color: white;\n    text-align: center;\n    padding: 20px;\n    font-size: 22px;\n    font-weight: bold;\n    background: url('https://tourexplorer.s3.ap-south-1.amazonaws.com/images/product/f6b9a69b-4a79-497a-bff5-1588625418e6.jpeg') center/cover;\n    border-top-left-radius: 14px;\n    border-top-right-radius: 14px;\n}\n\n.ticket-header::before {\n    content: \"\";\n    position: absolute;\n    top: 0;\n    left: 0;\n    width: 100%;\n    height: 100%;\n    /* background: linear-gradient(to bottom, rgba(0, 0, 0, 0.25), rgba(0, 0, 0, 0)); */\n    border-top-left-radius: 14px;\n    border-top-right-radius: 14px;\n}\n\n.ticket-header span {\n    position: relative;\n    z-index: 1;\n}\n\n/* Ticket Cutout Effect */\n.ticket:before,\n.ticket:after {\n    content: \"\";\n    position: absolute;\n    width: 20px;\n    height: 40px;\n    background: #fff;\n    border: 2px solid #f5f5f5;\n    /* border-radius: 50%;s */\n}\n\n.ticket:before {\n    top: 50%;\n    left: -2px;\n    transform: translateY(-50%);\n    z-index: 9999;\n    border-left: 0;\n    border-top-right-radius: 30px;\n    border-bottom-right-radius: 30px;\n}\n\n.ticket:after {\n    top: 50%;\n    right: -2px;\n    transform: translateY(-50%);\n    border-right: 0;\n    border-top-left-radius: 30px;\n    border-bottom-left-radius: 30px;\n}\n\n/* Ticket Body */\n.ticket-body {\n    padding: 10px 20px;\n    text-align: center;\n}\n\n.ticket-time {\n    font-size: 26px;\n    font-weight: bold;\n    color: #333;\n}\n\n.ticket-date {\n    font-size: 18px;\n    color: #777;\n    margin-bottom: 10px;\n}\n\n.ticket-divider {\n    border-top: 2px dashed #bbb;\n    margin: 12px 0;\n}\n\n/* Pricing Details */\n.ticket-info {\n    display: flex;\n    justify-content: space-between;\n    font-size: 16px;\n    margin-bottom: 8px;\n    color: #555;\n}\n\n.ticket-info i {\n    color: #e3bd3e;\n    margin-right: 6px;\n}\n\n/* Total Amount */\n.total-amount {\n    font-size: 18px;\n    font-weight: bold;\n    text-align: right;\n    color: #e3bd3e;\n}\n\n.personDrop select {\n    width: 100%;\n    border: 2px solid #E6E8EC !important;\n    border-radius: 10px;\n    padding: 5px 5px;\n    margin-top: 10px;\n    outline: none;\n}\n\n.selectDetails .ourClickBox .nextMonthDay {\n    display: none !important;\n}\n\n.gallery .galleryPart .imgGridBox .textBox {\n    padding-right: 10px;\n}\n\n.atag_btn {\n    /* display: block; */\n    /* width: 115px; */\n    /* height: 25px; */\n    background: transparent;\n    border: 1px solid #E3BD3E;\n    padding: 10px;\n    text-align: center;\n    border-radius: 5px;\n    color: white;\n    font-weight: bold;\n    line-height: 25px;\n    color: #E3BD3E;\n}\n\n.atag_btn:hover {\n    /* background: #E3BD3E; */\n    color: #E3BD3E;\n}\n\n.dropDownLoc li.newdropOpen ul.innerNewDrop {\n    width: 100%;\n    min-width: 460px !important;\n}\n\n.dropDownLoc li.newdropOpen ul.innerNewDrop li {\n    width: 33%;\n}\n\n.dropDownLoc li.newdropOpen ul.innerNewDrop li a {\n    word-break: break-word;\n}\n\n.dropDownLoc li.newdropOpen:hover ul.innerNewDrop {\n    display: inline-flex;\n}\n\n.personDrop .bokunDropBox ul.DropBox {\n    padding: 10px !important;\n}\n\n.personDrop .bokunDropBox ul.DropBox li {\n    margin-bottom: 0 !important;\n}\n\n.personDrop .bokunDropBox ul.DropBox li a {\n    padding: 0 15px !important;\n}\n\n.personDrop .discriplangDown a.main {\n    padding: 5px 12px;\n}\n\n.personDrop .discriplangDown a.main .iconDown {\n    height: 25px;\n    width: 25px;\n}\n\n.personDrop .discriplangDown a.main .iconDown i {\n    font-size: 13px;\n}\n\n.personDrop .boxCard .commonLabelSecond {\n    margin-top: 5px !important;\n}\n\n.mainListProducts .tabBtnbox ul li .custombtn .fa-chevron-right {\n    float: unset;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    right: 0;\n}\n\n.header-fav-icon a {\n    color: var(--text-black);\n    padding: 5px 10px;\n    border-radius: 30px;\n    font-family: 'Manrope-Bold';\n    transition: 0.3s;\n}\n\n.header-fav-icon a.active {\n    background-color: var(--white-color);\n}\n\n.header-fav-icon a i {\n    margin-right: 5px;\n    vertical-align: middle;\n}\n\n.full_description_text_activity img {\n    max-width: 100% !important;\n    height: auto !important;\n}\n\n.admin-visible-detail p {\n    line-height: 1;\n}\n\n.innerNewDrop {\n    display: flex;\n    flex-wrap: wrap;\n    max-width: 460px;\n}\n\n.innerNewDrop li {\n    width: calc(33.33% - 10px);\n    list-style: none;\n    text-align: left;\n}\n\n.location_mobile .dropDownLocMobile li .innerNewDrop li {\n    width: calc(100%) !important;\n}\n\n.time-selected {\n    background-color: #e3bd3e !important;\n}\n\nul.innerNewDrop a {\n    font-size: 12px !important;\n}\n\n.soldout-time {\n    border: unset !important;\n    color: #2c2f3a29 !important;\n    cursor: not-allowed !important;\n    /* opacity: 0.5 !important; */\n}\n\n.soldout-time:hover {\n    background-color: #E3BD3E1A !important;\n}\n\n.req-sym {\n    color: #fa5c7c;\n    margin-left: 0.3rem;\n}\n\n.checkout-form .cus-err {\n    position: relative !important;\n}\n\n.checkout-form .iti,\n.iti--allow-dropdown {\n    margin-bottom: 0 !important;\n\n}\n\n.cat-blog-short-desc {\n    display: -webkit-box;\n    -webkit-line-clamp: 4;\n    -webkit-box-orient: vertical;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    max-width: 100%;\n}\n\n.innerFormBox .box-box {\n    width: calc(50%);\n}\n\n.innerFormBox {\n    display: flex;\n    /* grid-template-columns: 1fr 1fr; */\n    gap: 30px;\n    margin-bottom: 25px;\n}\n\n.select2.select2-container {\n    width: 100% !important;\n}\n\nspan.selection {\n    width: 100%;\n}\n\n.select2.select2-container .selection .select2-selection {\n    border: 2px solid #E6E8EC;\n    display: flex;\n    align-items: center;\n    /* padding: 20px 0px; */\n    height: 48px;\n    border-radius: 10px;\n}\n\n.select2-container--default .select2-selection--single .select2-selection__arrow {\n    top: 50% !important;\n    transform: translateY(-50%);\n    height: 35px !important;\n    width: 35px !important;\n    border: 2px solid #E6E8EC;\n    border-radius: 50%;\n    right: 15px !important;\n}\n\n.select2-container--default .select2-selection--single .select2-selection__arrow::after {\n    content: '\\f078';\n    position: absolute;\n    font-family: 'fontawesome';\n    font-size: 16px;\n    padding: 3px 8px;\n}\n\n.confirm_left .select2-container--default .select2-selection--single .select2-selection__arrow b {\n    display: none;\n}\n\n.discriplangDown a.main {\n    padding: 6px 15px;\n}\n\n.react-date-picker {\n    width: 100%;\n}\n\n.react-date-picker__wrapper {\n    border: none !important;\n    padding: 8px 15px !important;\n    border-radius: 12px !important;\n    border: 2px solid var(--border-color) !important;\n}\n\n.react-date-picker__inputGroup {\n    color: #7A7C86 !important;\n    font-size: 14px !important;\n    font-family: 'Manrope-Medium' !important;\n}\n\n.react-date-picker__button svg {\n    stroke: #7A7C86 !important;\n}\n\n.react-date-picker__button svg:hover {\n    stroke: #E3BD3E !important;\n}\n\n.react-calendar {\n    border: none !important;\n    border-radius: 30px;\n    background-color: #FCFCFD !important;\n    /* box-shadow: 0 40px 32px -24px #0F0F0F1F !important; */\n    box-shadow: 0 0px 5px 0px #0F0F0F1F !important;\n    padding: 15px 10px;\n}\n\n.react-calendar__month-view .react-calendar__tile {\n    font-size: 14px !important;\n    width: 50px !important;\n    max-width: 45px !important;\n    height: 45px;\n    font-family: 'Poppins-Medium' !important;\n}\n\n.react-calendar__month-view .react-calendar__tile--active {\n    color: var(--dark-box) !important;\n    border-radius: 50% !important;\n    background: #ECBB33 !important;\n    padding: 0 !important;\n}\n\n/* .react-calendar__month-view__days__day--neighboringMonth {\n    color: var(--dark-box) !important;\n} */\n\n.react-calendar__month-view__days {\n    display: grid !important;\n    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;\n}\n\n.react-calendar__month-view .react-calendar__month-view__weekdays {\n    color: #83889B !important;\n    font-family: 'Gilory-SemiBold' !important;\n    text-transform: capitalize !important;\n    text-decoration: none !important;\n    font-size: 14px !important;\n}\n\n.react-calendar__month-view .react-calendar__month-view__weekdays abbr[title] {\n    text-decoration: unset !important;\n    font-family: 'Gilory-SemiBold' !important;\n}\n\n.react-calendar__month-view .react-calendar__month-view__days__day--weekend {\n    color: var(--dark-box);\n}\n\n.react-calendar__navigation .react-calendar__navigation__label__labelText {\n    font-size: 18px;\n    color: var(--dark-box);\n    font-family: 'Manrope-Bold' !important;\n}\n\n.react-calendar__month-view__days__day--neighboringMonth {\n    color: #757575 !important;\n}\n\n.react-calendar__tile--now {\n    background: transparent !important;\n}\n\n.react-calendar__month-view .react-calendar__tile:enabled:hover,\n.react-calendar__month-view .react-calendar__tile:enabled:focus {\n    /* background-color: #ECBB33 !important; */\n    border-radius: 50% !important;\n}\n\n.react-calendar__year-view .react-calendar__tile--hasActive,\n.react-calendar__decade-view__years .react-calendar__tile--hasActive,\n.react-calendar__century-view__decades .react-calendar__tile--hasActive {\n    background: #ECBB33 !important;\n}\n\n.react-calendar__year-view .react-calendar__tile,\n.react-calendar__decade-view__years .react-calendar__tile,\n.react-calendar__century-view__decades .react-calendar__tile {\n    padding: 12px 20px !important;\n    border-radius: 30px;\n    color: var(--dark-box);\n    font-size: 14px;\n    font-family: 'Gilory-SemiBold' !important;\n    /* font-family: 'Gilroy-Bold'!important; */\n    margin-bottom: 10px;\n}\n\n.react-calendar__century-view__decades .react-calendar__tile {\n    padding: 12px 5px !important;\n}\n\n.confirm_and_pay .confirm_left .select2-container--default .select2-selection--single .select2-selection__placeholder {\n    font-family: 'Poppins-Medium';\n    color: #23262F;\n}\n\n.verification-modal .modal-dialog {\n    max-width: 480px;\n}\n\n.verification-modal .modal-content {\n    border-radius: 16px;\n}\n\n.verification-modal .modal-body {\n    text-align: center;\n    padding: 30px 30px;\n    border-radius: 16px;\n}\n\n.verification-modal .modal-body a>img {\n    width: 100%;\n    max-width: 190px;\n}\n\n.verification-modal .modal-body h4 {\n    color: #0F172A;\n    font-size: 30px;\n    margin: 15px 0;\n    font-family: 'Gilroy-Bold';\n}\n\n.verification-modal .modal-body h6 {\n    font-size: 14px;\n    color: #94A0AD;\n    margin-bottom: 25px;\n    font-family: 'Gilroy-Bold';\n}\n\n.verification-modal .modal-body .register p {\n    color: #475569;\n    font-size: 16px;\n    font-family: 'Manrope-SemiBold';\n    margin-top: 20px;\n}\n\n.verification-modal .modal-body .register p a {\n    font-family: 'Manrope-SemiBold';\n}\n\n.blogContainer .commonInput {\n    margin-bottom: 0;\n    background-color: #f5f5f0;\n    padding-right: 25px;\n}\n\n.blogContainer .commonInput::placeholder {\n    font-family: 'Poppins-Regular';\n    color: var(--gray-color);\n}\n\n.blogSearch {\n    position: relative;\n}\n\n.blogSearch i {\n    position: absolute;\n    right: 10px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: var(--gray-color);\n}\n\n.pageSection2.blogPage .Section2Box .placeSec {\n    margin-top: 0;\n}\n\n.customTitle {\n    color: #334155;\n    font-family: 'Manrope-Bold';\n}\n\n.confirm_left .paymentTab {\n    margin-bottom: 0;\n}\n\n.confirm_left .paymentTab .continueBox {\n    margin-top: 30px;\n}\n\n/* .StripeElement {\n    padding: 12px 15px;\n    border-radius: 12px;\n    border: 2px solid var(--border-color);\n} */\n.stripe-custom-form .commonInputSecond {\n    padding: 13px !important;\n\n}\n\n.stripe-custom-form .card-branding {\n    border: unset !important;\n}\n\n.checkoutsublabels {\n    color: #334155 !important;\n    margin-bottom: 5px;\n}\n\n.location-page-exp {\n    padding: 10px 0 !important;\n}\n\n.blogPage .pagenext {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    margin-top: 25px;\n}\n\n.profilePhoneInput .cus-err {\n    bottom: -20px !important;\n}\n\n.detailsMore span.greenstatuspaid {\n    background: #17C964;\n    padding: 0px 10px;\n    border-radius: 5px;\n    font-size: 12px;\n    color: black;\n    padding: 4px 4px;\n}\n\n.detailsMore span.comtagSpan {\n    padding: 0px 10px;\n    border-radius: 5px;\n    font-size: 14px;\n    font-family: 'Manrope-SemiBold' !important;\n}\n\n.detailsMore span.comtagSpan.green {\n    background-color: #17C96433;\n    color: #09A54D;\n}\n\n.detailsMore span.comtagSpan.blue {\n    background-color: #006FEE33;\n    color: #006FEE;\n}\n\n.booking-pagination-par .pagenext {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n}\n\n.booking-product-list-select .select2-selection__rendered {\n    width: 100% !important;\n}\n\n.detailsMore .accordion-body .ourbtnsec .btn.resendbtn {\n    color: #292D32;\n    background-color: #E3BD3E;\n    border: unset;\n}\n\n.detailsMore .accordion-body .ourbtnsec .btn.cancelbtn {\n    background-color: #DC2626;\n    border: unset;\n    color: white;\n\n}\n\n.activityhead .breadcrumb {\n    margin: 0;\n}\n\n/*  */\n\n.payment-container {\n    /* background: rgba(255, 255, 255, 0.95); */\n    padding: 0px 40px;\n    width: 420px;\n    text-align: center;\n    border-radius: 16px;\n    /* box-shadow: 0px 10px 30px rgba(0, 0, 0, 0.12); */\n    position: relative;\n    backdrop-filter: blur(10px);\n}\n\n.payment-icon {\n    width: 80px;\n    height: 80px;\n    background: #e3bd3e;\n    color: white;\n    font-size: 36px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    margin: 0 auto 20px;\n    box-shadow: 0px 5px 15px rgba(227, 189, 62, 0.3);\n}\n\n.processing-title {\n    font-size: 30px;\n    font-weight: 600;\n    margin-bottom: 10px;\n    color: #23262F;\n    font-family: 'Manrope-SemiBold';\n}\n\n.processing-loading-text {\n    font-size: 16px;\n    font-weight: 700;\n    color: #94A3B8;\n    font-family: 'Manrope-Regular';\n}\n\n.processing-expire-note {\n    font-size: 16px;\n    font-weight: 600;\n    color: #475569;\n    font-family: 'Manrope-Regular';\n}\n\n/*  */\n\n.registerBox .form-group .btnShow {\n    position: absolute;\n    top: 50%;\n    right: 0;\n    color: #83889B;\n    box-shadow: none !important;\n    transform: translateY(-50%);\n}\n\n.registerBox .form-group {\n    position: relative;\n}\n\n.registerBox .form-group .lineSpan {\n    padding: 15px 0;\n}\n\n.registerBox .form-group label {\n    color: #292929;\n    font-size: 14px;\n    font-family: 'Manrope-Medium';\n    padding-bottom: 10px;\n}\n\n.custom-ui {\n    text-align: center;\n    width: 500px;\n    padding: 40px;\n    /* background: #28bae6; */\n    background-color: var(--gold-color);\n    color: var(--text-black) !important;\n    box-shadow: 0 20px 75px rgba(0, 0, 0, 0.23);\n    /* color: #fff !important; */\n    border-radius: 10px !important;\n}\n\n.custom-ui>button {\n    width: 160px !important;\n    padding: 10px !important;\n    border: 1px solid #fff;\n    margin: 10px !important;\n    cursor: pointer;\n    background: none;\n    color: #fff;\n    font-size: 14px;\n}\n\n.custom-ui>h1 {\n    font-family: 'Manrope-SemiBold' !important;\n    margin-top: 0;\n    color: #fff;\n    font-size: 2.5rem !important;\n\n}\n\n.custom-ui>p {\n    margin-top: 0;\n    color: #fff;\n\n}\n\n.imgText {\n    cursor: pointer !important;\n}\n\n.custom-ui button:hover {\n    background: white !important;\n    color: var(--gold-color) !important;\n}\n\n.verification-modal.confirmation-modal .modal-dialog {\n    max-width: 567px;\n}\n\n.verification-modal.confirmation-modal .modal-body h4 {\n    color: #23262F;\n    font-family: 'Manrope-Bold' !important;\n}\n\n.verification-modal.confirmation-modal .modal-body h6 {\n    color: #94A3B8;\n    font-family: 'Manrope-Regular' !important;\n}\n\n.verification-modal.confirmation-modal .continueBox {\n    display: flex;\n    gap: 10px;\n}\n\n.verification-modal.confirmation-modal .continueBox .continueBtn {\n    width: calc(50%);\n    background: #fff;\n    border: 1px solid var(--gold-color);\n    font-family: 'Manrope-SemiBold' !important;\n}\n\n.verification-modal.confirmation-modal .continueBox .continueBtn:hover {\n    background: var(--gold-color);\n}\n\n.modal-backdrop.show {\n    opacity: .9;\n    background-color: var(--dark-box)d9;\n}\n\n.detailsMore .accordion-body .ourbtnsec {\n    margin-top: 20px;\n    display: flex;\n    justify-content: center;\n    gap: 10px;\n}\n\n.detailsMore .accordion-body .ourbtnsec .btn.two {\n    width: calc(50% - 10px);\n}\n\n.detailsMore .accordion-body .ourbtnsec .btn.single {\n    width: calc(100%);\n}\n\n.customBtnGold {\n    background: var(--gold-color);\n    width: 100px;\n    font-family: 'Manrope-Bold';\n    border-radius: 30px;\n    min-height: 45px;\n    color: #23252E;\n    outline: unset;\n    border: unset;\n}\n\n.profileBackbtnContainer {\n    display: flex;\n    align-items: flex-start;\n    justify-content: space-between;\n}\n\nspan.red {\n    color: #F31260;\n    background-color: #F3126033;\n}\n\n.redColorText {\n    color: #950606 !important;\n}\n\n.topstatus {\n    font-size: 12px !important;\n    padding: 4px 10px !important;\n}\n\n.search-title {\n    margin-bottom: 10px !important;\n}\n\n.typeBox .search-key ul li:not(:last-child),\nheader .header-box .menuBox .search-key ul li:not(:last-child) {\n    margin-bottom: 0px !important;\n}\n\n.typeBox .search-key ul li a,\nheader .header-box .menuBox .search-key ul li a {\n    padding: 5px 5px !important;\n\n}\n\n.cancelRedBtn {\n    background-color: #e53935;\n    /* Bright red */\n    color: #fff;\n    /* White text */\n    border: none;\n    padding: 10px 20px;\n    font-size: 16px;\n    font-weight: 500;\n    border-radius: 6px;\n    cursor: pointer;\n    transition: background-color 0.3s ease;\n}\n\n.cancelRedBtn:hover {\n    background-color: #c62828;\n    /* Darker red on hover */\n}\n\n.whatsappbtn {\n    background-color: #25D366 !important;\n    color: white !important;\n}\n\n.detailsMore .accordion-body .ourbtnsec .btn i {\n    vertical-align: initial !important;\n}\n\n.mainListProducts .tabBtnbox ul li .custombtn svg {\n    vertical-align: bottom;\n    margin-right: 10px;\n}\n\n.dropDownLoc.iocnDropdwon {\n    width: auto !important;\n}\n\n.dropDownLoc.iocnDropdwon li a {\n    justify-content: start !important;\n    gap: 10px !important;\n}\n\n.dropdownBox span.dropdown-icon {\n    margin-right: 5px;\n    vertical-align: text-bottom;\n}\n\n/*  */\n/* Hide all language sections by default */\n.English-section,\n.French-section,\n.German-section,\n.Italian-section,\n.Portuguese-section,\n.Other-section,\n.Spanish-section {\n    display: none;\n}\n\n.goog-te-banner-frame {\n    display: none !important;\n}\n\n/* Show the matching section based on body class */\nbody.English .English-section {\n    display: block;\n}\n\nbody.French .French-section {\n    display: block;\n}\n\nbody.German .German-section {\n    display: block;\n}\n\nbody.Italian .Italian-section {\n    display: block;\n}\n\nbody.Portuguese .Portuguese-section {\n    display: block;\n}\n\nbody.Spanish .Spanish-section {\n    display: block;\n}\n\nbody.Other .Other-section {\n    display: block;\n}\n\nbody.Other .goog-te-banner-frame {\n    display: block !important;\n}\n\n.tandcLink {\n    color: #ECBB33 !important;\n    text-decoration: underline;\n    font-size: 16px;\n    font-family: 'Manrope-Medium';\n}\n\n.tandcMainDiv {\n    display: flex;\n    gap: 10px;\n    flex-wrap: wrap;\n}\n\n.skiptranslate {\n    opacity: 0;\n    visibility: hidden;\n}\n\nbody.Other .skiptranslate {\n    opacity: 1;\n    visibility: visible;\n}\n\n/* .skiptranslate {\n    display: none !important;\n}\n\nbody.Other .skiptranslate {\n   display: block ;\n} */\n\nbody {\n    top: 0px !important;\n}\n\niframe .VIpgJd-ZVi9od-TvD9Pc-hSRGPd {\n    display: none !important;\n}\n\n.VIpgJd-ZVi9od-aZ2wEe-wOHMyf.VIpgJd-ZVi9od-aZ2wEe-wOHMyf-ti6hGc {\n    display: none !important;\n}\n\n.footerPart .footerBox .innerBox .footermenu.fiveBox ul li span img {\n    width: 100% !important;\n    max-width: 30px !important;\n}\n\n.blog-cat-opt {\n    width: 30%;\n}\n\n.currencyDrop {\n    opacity: 0.5;\n}\n\n.currencyDrop a {\n    cursor: not-allowed;\n}\n\n.goog-te-banner-close {\n    display: none !important;\n}\n\n#full_description_text_cms table {\n    width: 100%;\n    border-collapse: collapse;\n    table-layout: auto;\n    /* or fixed if you want consistent column widths */\n}\n\n#full_description_text_cms td,\n#full_description_text_cms th {\n    word-wrap: break-word;\n    /* padding: 8px; */\n    /* border: 1px solid #ddd;s */\n}\n\n#full_description_text_cms td img {\n    width: 100% !important;\n    height: 100% !important;\n    object-fit: contain;\n}\n\n#full_description_text_cms table {\n    width: 100% !important;\n}\n\n#full_description_text_cms table td h4,\n#full_description_text_cms table td h1 {\n    font-family: 'Manrope-Bold';\n}\n\n#full_description_text_cms table td p {\n    font-family: 'Manrope-Regular';\n}\n\n.custom-red-label {\n    color: red;\n    font-family: 'Manrope-Bold';\n    font-size: 22px;\n    margin-bottom: 20px;\n    /* padding-left: 15px; */\n}\n\n.comon-tags-class h1 {\n    font-family: 'Manrope-Bold';\n    font-size: 48px;\n    /* color: #0F172A !important; */\n    color: #f39c12 !important;\n\n}\n\n.comon-tags-class h2 {\n    font-family: 'Manrope-Bold';\n    font-size: 40px;\n    color: #BBBE11 !important;\n}\n\n.comon-tags-class h3 {\n    font-family: 'Manrope-Bold';\n    font-size: 32px;\n    color: #ECBB33 !important;\n}\n\n.comon-tags-class h4 {\n    font-family: 'Manrope-Bold';\n    font-size: 24px;\n    color: #EEC144 !important;\n}\n\n.comon-tags-class h5 {\n    font-family: 'Manrope-Bold';\n    font-size: 20px;\n    color: #334155 !important;\n}\n\n.comon-tags-class h6 {\n    font-family: 'Manrope-Bold';\n    font-size: 18px;\n    color: #FCD34D !important;\n}\n\n#goog-gt-tt {\n    display: none !important;\n    visibility: hidden !important;\n    opacity: 0 !important;\n    z-index: -9999 !important;\n}\n\n#goog-gt-tt {\n    position: absolute !important;\n    top: 20px !important;\n    /* move to top */\n    left: 20px !important;\n    z-index: 9999 !important;\n}\n\n.faqs_section .question_box {\n    padding-left: 15px !important;\n}\n\n.contact-us-content .about_banner {\n    padding-bottom: 0px;\n}\n\nbody.dark .comon-tags-class h5,\nbody.dark .comon-tags-class h2,\nbody.dark .faqs_section .accordion-button,\nbody.dark .faqs_section .accordion-body {\n    color: #fff !important;\n}\n\nbody.dark .send_email span {\n    color: #B1B5C3 !important;\n}\n\nbody.dark .faqs_section .accordion-item {\n    background-color: var(--dark-box) !important;\n}\n\n.content_box_dyn {\n    padding: 0 15px;\n}\n\nbody.dark .menuBread .breadcrumb-item+.breadcrumb-item::before {\n    filter: invert(0.6);\n}\n\n.full_description_text iframe {\n    width: 100%;\n}\n\n\n.full_description_text blockquote {\n    font-style: italic;\n    padding: 2px 0;\n    border-style: solid !important;\n    border-color: #ccc !important;\n    border-width: 0;\n    padding-left: 20px;\n    padding-right: 8px;\n    border-left-width: 5px;\n}\n\nblockquote {\n    display: block;\n    margin-block-start: 1em;\n    margin-block-end: 1em;\n    margin-inline-start: 40px;\n    margin-inline-end: 40px;\n    unicode-bidi: isolate;\n}\n\nblockquote {\n    border-left: 4px solid #ccc;\n    padding-left: 1em;\n    margin: 1em 0;\n    color: #444;\n    background-color: #f9f9f9;\n    font-style: italic;\n}\n\n.notranslate {\n    translate: no !important;\n}\n\n.timeBox_second {\n    margin-top: 16px;\n}\n\n.bookRightBox .adultDropBox ul li .adultage {\n    width: 100%;\n    max-width: 75%;\n}\n\n.bookRightBox .adultDropBox ul li .personDrop {\n    width: 100%;\n    max-width: 25%;\n}\n\n.menuBread .breadcrumb .breadcrumb-item span {\n    word-break: break-word;\n    display: flex;\n}\n\n.bookRightBox .adultDropBox ul li .personDrop .countBtn {\n    display: flex;\n}\n\n\n\n.ourClickBox span.flatpickr-weekday {\n    translate: unset !important\n}\n\n/*  */\n.full_description_text_activity table {\n    width: 100%;\n    border-collapse: collapse;\n    margin-top: 1em;\n    border: 1px solid #ccc;\n}\n\n.full_description_text_activity th,\n.full_description_text_activity td {\n    border: 1px solid #ccc;\n    padding: 0.6em 0.8em;\n    vertical-align: top;\n}\n\n.full_description_text_activity th {\n    text-align: left;\n    font-size: 1.2em;\n    color: #f0b429;\n    background-color: #f9f9f9;\n}\n\n.full_description_text_activity tr td:first-child {\n    font-weight: bold;\n    white-space: nowrap;\n    width: 140px;\n}\n\n.full_description_text_activity strong {\n    font-weight: bold;\n    /* color: #000; */\n}\n\n.full_description_text_activity {\n    font-size: 1em;\n    line-height: 1.5;\n    color: #333;\n    background-color: #fefefe;\n}\n\n.meetingPoint .clickMap .realExpMapBox {\n    margin-top: 20px;\n}\n\n.meetingPoint .clickMap .realExpMapBox iframe {\n    width: 100%;\n    min-height: 300px;\n    border-radius: 24px;\n}\n\n.meetingPoint .clickMap .routeMapBox {\n    margin-top: 20px;\n}\n\n.meetingPoint .clickMap .routeMapBox iframe {\n    width: 100%;\n    min-height: 300px;\n    border-radius: 24px;\n}\n\n.filterSidebarList {\n    max-height: 250px;\n    overflow: auto;\n}\n\n/*  */\n\n\n.ourClickBox .comSeacrh_input .titleCat {\n    display: flex;\n    align-items: center;\n    gap: 5px;\n    width: 100%;\n}\n\n.ourClickBox .comSeacrh_input .titleCat p {\n    margin-bottom: 0 !important;\n}\n\n.ourClickBox .comSeacrh_input .searchBox {\n    position: relative;\n    margin: 10px 0;\n    min-height: 45px;\n    width: 100%;\n}\n\n.ourClickBox .comSeacrh_input .searchBox a.iconS,\n.ourClickBox .comSeacrh_input .searchBox a.iconX {\n    background: var(--white-color);\n    height: 33px;\n    width: 33px;\n    border-radius: 5px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    position: absolute;\n    top: 50%;\n    transform: translateY(-50%);\n    transition: 0.6s;\n    right: 5px;\n    float: right;\n    border: 1px solid #ccc;\n}\n\n.ourClickBox .comSeacrh_input .searchBox a.iconS {\n    z-index: 2;\n}\n\n.ourClickBox .comSeacrh_input .searchBox.active a.iconS {\n    background: var(--white-color);\n    transition: 0.5s;\n}\n\n.ourClickBox .comSeacrh_input .searchBox a.iconX {\n    opacity: 0;\n}\n\n.ourClickBox .comSeacrh_input .searchBox.active a.iconX {\n    right: 5px;\n    border: 1px solid var(--border-color);\n    opacity: 1;\n    z-index: 55;\n}\n\n.ourClickBox .comSeacrh_input .searchBox a i {\n    color: var(--text-black);\n    font-size: 18px;\n}\n\n.ourClickBox .comSeacrh_input .searchBox input {\n    background: var(--white-color);\n    border: none;\n    box-shadow: none;\n    height: 40px;\n    width: 0px;\n    border-radius: 50%;\n    transition: 0.5s;\n    opacity: 0;\n    outline: none;\n    float: right;\n}\n\n.ourClickBox .comSeacrh_input .searchBox.active input {\n    max-width: 270px;\n    border-radius: 7px;\n    height: 45px;\n    padding: 0 42px 0px 10px;\n    width: 100%;\n    border: 1px solid var(--border-color);\n    opacity: 1;\n}\n\n.ourClickBox .comSeacrh_input .searchBox input::placeholder {\n    color: #C3C4C7;\n    font-size: 16px;\n    font-family: 'Gilory-SemiBold';\n}\n\n.redText {\n    color: #b10000;\n    font-family: 'Gilroy-Bold';\n}\n\n/* h2 {\n    font-family: 'Segoe UI Emoji', 'Apple Color Emoji', 'Noto Color Emoji', sans-serif !important;\n    font-size: 2em !important;\n\n} */\n\n/* .booking .bookingBox .bookLeftBox {\n    margin-top: 50px;\n} */\n\n.cookie-modal {\n    padding-left: 0 !important;\n}\n\n.cookie-modal .modal-dialog {\n    max-width: 640px;\n}\n\n.cookie-modal .modal-content {\n    border-radius: 16px;\n    box-shadow: 5px 15px 20px 0px #00000040;\n}\n\n.cookie-modal .modal-body {\n    padding: 30px 30px 20px;\n}\n\n.cookie-modal .first_box h5 {\n    color: var(--dark-box);\n    font-family: 'Manrope-Bold';\n}\n\n.cookie-modal .first_box p {\n    color: #334155;\n    font-family: 'Manrope-Regular';\n    font-size: 12px;\n}\n\n.cookie-modal .modal-footer {\n    justify-content: center;\n    border: none;\n    padding: 0px 30px 30px;\n    gap: 15px;\n}\n\n.cookie-modal .modal-footer .btn_reject {\n    font-size: 14px;\n    color: var(--dark-box);\n    border: 1px solid #F6E0A2;\n    font-family: 'Manrope-SemiBold';\n    box-shadow: none;\n    outline: none;\n    padding: 10px 25px;\n    margin: 0;\n    border-radius: 30px;\n    white-space: nowrap;\n}\n\n.cookie-modal .modal-footer .btn_accept {\n    font-size: 14px;\n    color: var(--dark-box);\n    border: 1px solid #ECBB33;\n    background-color: #ECBB33;\n    font-family: 'Manrope-SemiBold';\n    box-shadow: none;\n    outline: none;\n    padding: 10px 25px;\n    margin: 0;\n    border-radius: 30px;\n    white-space: nowrap;\n}\n\n.cookie-modal .privacy_overview {\n    margin-top: 30px;\n}\n\n.cookie-modal .privacy_overview .overview_box {\n    padding: 15px 20px;\n    border: 2px solid #E2E8F0;\n}\n\n.cookie-modal .privacy_overview .overview_box:first-child {\n    border-top-left-radius: 10px;\n    border-top-right-radius: 10px;\n}\n\n.cookie-modal .privacy_overview .overview_box:last-child {\n    border-bottom-left-radius: 10px;\n    border-bottom-right-radius: 10px;\n}\n\n.cookie-modal .privacy_overview .overview_box h6 {\n    color: var(--dark-box);\n    font-size: 14px;\n    font-family: 'Manrope-Bold';\n    margin-bottom: 10px;\n}\n\n.cookie-modal .privacy_overview .switch_view_box p {\n    color: #334155;\n    font-size: 14px;\n    font-family: 'Manrope-Regular';\n}\n\n.cookie-modal .privacy_overview .switch_view_box {\n    display: flex;\n    align-items: center;\n    gap: 20px;\n}\n\n.cookie-modal .switch_view_box .swicth_box .form-switch .form-check-input {\n    background-color: #6E7191;\n    border-color: #6E7191;\n    min-height: 19px;\n    width: 40px;\n    box-shadow: none;\n    outline: none;\n    background-image: url(../images/white-round.svg) !important;\n    margin-top: 0;\n    cursor: pointer;\n}\n\n.cookie-modal .switch_view_box .swicth_box .form-switch .form-check-input:checked {\n    background-color: #ECBB33;\n    border-color: #ECBB33;\n}\n\n.mainContentBox .activityBox .showmoreBtn a {\n    color: #b10000 !important;\n}\n\n\n/* ======= */\n\n.accessibleBox .ourClickBox {\n    display: flex;\n    gap: 30px;\n    padding: 10px 0;\n    margin-bottom: 10px;\n}\n\n.accessibleBox .typecheck {\n    padding-left: 0 !important;\n}\n\n.accessibleBox .typecheck .form-check-input {\n    box-shadow: none !important;\n    outline: none !important;\n    margin-right: 10px;\n    height: 20px;\n    width: 20px;\n    border: 2px solid var(--border-color);\n}\n\n.accessibleBox .typecheck .keyword-label {\n    font-size: 16px;\n    color: #11181C;\n    font-family: 'Manrope-Bold';\n}\n\n.accessibleBox .typecheck .form-check-input:checked,\n.form-radio-warning .form-check-input:checked {\n    background-color: #F5A524;\n    border-color: #F5A524;\n}\n\n.pickup_box ul {\n    padding: 10px 0px 10px 30px;\n}\n\n.pickup_box ul li {\n    list-style: disc;\n    padding-left: 0px;\n}\n\n.pickup_box ul li p {\n    font-size: 16px;\n    color: #23252E;\n    font-family: 'Manrope-Bold';\n}\n\n.pickup_box ul li span {\n    color: #777777;\n    display: inline;\n}\n\n.pickup_box .list-loader-container {\n    margin-top: 10px !important;\n    justify-content: unset !important;\n    margin-left: 10% !important;\n}\n\n.pickup_box .listloader {\n    width: 30px !important;\n}\n\n/* .pageSection2 .showMore {\n    padding-right: 20px;\n} */\n\n/* #mobileSlider-1 .owl-stage-outer {\n    overflow: visible;\n    padding-right: 60px;\n}\n\n#mobileSlider-1 {\n    padding-right: 40px;\n}\n\n\n#mobileSlider-1 .owl-item {\n    transition: transform 0.3s;\n}\n\n#mobileSlider-1 .owl-item.active .item {\n    transform: scale(1);\n}\n\n#mobileSlider-1 .owl-item .item {\n    transform: scale(0.96);\n} */\n\n.react-calendar__tile:disabled {\n    background-color: #f0f0f0;\n    color: #ababab !important;\n}\n\nbody.dark .notfoundLabel {\n    background-color: #2c2c2c !important;\n}\n\nbody.dark .pickup_box ul li p {\n    font-size: 16px;\n    color: var(--textP-color) !important;\n    font-family: 'Manrope-Bold';\n}\n\n.redHeart {\n    color: red !important;\n}\n\nbody.dark .detasilTitle .detasilBox ul li a i.redHeart {\n    color: red !important;\n}\n\n.bookRightBox .flatpickr-calendar:before,\n.flatpickr-calendar:after {\n    display: none !important;\n}\n\nbody.dark .header-fav-icon a.active {\n    background-color: var(--dark-box);\n\n}\n\nbody.dark .header-fav-icon a {\n    color: #CBD5E1 !important;\n}\n\nbody.dark .dark_common_modal .modal-body,\nbody.dark .dark_common_modal .modal-content {\n    background-color: var(--dark-box) !important;\n}\n\nbody.dark .verification-modal.confirmation-modal .continueBox .continueBtn {\n    border-color: #334155;\n    background: transparent;\n    color: #CBD5E1;\n}\n\nbody.dark .verification-modal.confirmation-modal .modal-body h6,\nbody.dark .amountDetail .amountBox ul li p span,\nbody.dark .amountDetail .amountBox ul li p {\n    color: #94A3B8;\n}\n\nbody.dark .processing-title,\nbody.dark .processing-expire-note,\nbody.dark .dark_common_modal .modal-header .modal-title {\n    color: #CBD5E1;\n}\n\nbody.dark .amountDetail .amountBox ul li p:nth-child(even) {\n    background-color: #2F2304;\n}\n\nbody.dark .verification-modal .modal-body .register p {\n    color: #94A3B8;\n}\n\nbody.dark .getOtpBox .commonInput {\n    background-color: var(--dark-box);\n    border-color: #334155;\n    color: #CBD5E1;\n}\n\nbody.dark .dark_common_modal .commonGoldBtn,\nbody.dark .loginSec .loginpart .loginBox .loginBtn .btn-login {\n    color: var(--dark-box) !important;\n}\n\nbody.dark .commonLabel,\nbody.dark .loginSec .loginpart .loginBox .remember .checkBox .clickTo .keyword-label {\n    color: #CBD5E1;\n}\n\nbody.dark .commonInput {\n    background-color: var(--dark-box);\n    border-color: #334155;\n    color: #CBD5E1;\n}\n\nbody.dark .commonInput::placeholder,\nbody.dark .confirm_left .tab-pane .checkAndGo .clickTo .keyword-label {\n    color: #94A3B8;\n}\n\nbody.dark .loginSec .loginpart .loginBox {\n    background-color: var(--dark-box);\n}\n\n.countBtn .disabled {\n    pointer-events: none;\n    opacity: 0.5;\n    cursor: not-allowed;\n}\nbody.dark .redColorText {\n    color: #950606 !important;\n}\n\n.range-slider input[type=range] {\n    position: absolute;\n    pointer-events: all;\n}\n\n.range-slider input[type=range].on-top {\n    z-index: 2;\n}\n\n.ourClickBox .dayContainer {\n    min-width: 100% !important;\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr 1fr 1fr 1fr 1fr;\n    text-align: center;\n    width: 100%;\n    max-width: 100%;\n}\n.ourClickBox .flatpickr-day {\n    width: 100%;\n    text-align: center;\n    margin: 0 auto;\n}\nbody.dark .ourClickBox .comSeacrh_input .searchBox.active input {\n    background-color: var(--dark-box) !important;\n        color: #CBD5E1 !important;\n}\n\n.confirm_left .paymentTab .nav-tabs .nav-link img {\n    margin: 0 auto;\n}\n.bookNowLink{\n    color: #ECBB33 !important;\n    font-family: 'Gilroy-Bold';\n    font-size: 16px;\n    text-decoration: none;\n    border: 1px solid #ECBB33;\n    padding: 6px 15px;\n    border-radius: 30px;\n}\nbody.dark .bookNowLink{\n    color: #b10000  !important;\n\n}\n\n.comon-tags-class p a{\n    display: inline-block !important;\n    margin: 0 5px !important;\n}\n\n.mobile_search_input {\n    display: flex;\n    align-items: center;\n    gap: 10px;\n}\n\na.smalllogo img {\n    max-width: 45px !important;\n}\n\n/* @media (max-width:991px) {\n    .header-part .searchBox {\n        display: block !important;\n    }\n} */\n\nimg {\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  -webkit-user-drag: none;\n  user-select: none;\n}\n\n@media (max-width:479px) {\n    .filterpagereview .ti-header.source-Tripadvisor, \n    .filterpagereview .ti-header.ti-header-grid.source-all, \n    .filterpagereview .ti-header.ti-header-grid.source-Google {\n        padding: 5px !important;\n    }\n}\n\n.pageSection2 .Section2Box .travelBox .imgBox.skeleton::after{\n    border-radius: 30px 30px 0px 0px !important;\n}\n\n.pageSection2 .Section2Box .travelBox .textBox ul .skeleton,\n.pageSection2 .Section2Box .priceBox .priceListTag.skeleton, \n.pageSection2 .Section2Box .priceBox .listRating.skeleton {\n    min-height: 30px;\n    min-width: 80px;\n}\n.pageSection2 .Section2Box .container .sectionTitle.skeleton{\n    min-height: 54px;\n    min-width: 40px;\n    max-width: 40%;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
